import { jsxs as te, jsx as E, Fragment as se } from "react/jsx-runtime";
import ge, { useState as Je, useMemo as Pe, useCallback as Rt, createElement as Vr } from "react";
import { Check as zr, Plus as Xr, ChevronUp as Zr, ChevronDown as qr, Hide as Dr, Car as Jr, Discover as Qr } from "@indeed/ifl-icons";
import { Label as en, Text as It, Box as oe, Heading as Qe, VisuallyHidden as Ar, FormField as et, Input as tn, ChipFormField as rn, Button as nn, SelectFormField as an, Alert as Sr, Flex as on } from "@indeed/ifl-components";
import { themed as ln } from "@indeed/ifl-css";
import { makeVar as sn, useReactiveVar as cn } from "@apollo/client";
import { useI18n as Lt } from "@indeed/jspl-i18n";
import { LocationInputComponent as un } from "@indeed/location-input-component";
const ie = {
  outerLabel: {
    cursor: "pointer",
    userSelect: "none",
    borderRadius: "md",
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    border: "1px solid",
    borderColor: "border.weak",
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingLeft: "8px",
    paddingRight: "16px",
    marginBottom: 2,
    color: "primary.800",
    ':hover, :hover:not([aria-disabled="true"])': {
      backgroundColor: "primary.200",
      borderColor: "primary.600",
      color: "primary.900"
    },
    ":focus-within, :active": {
      outline: "solid 1px",
      outlineColor: "primary.800",
      outlineOffset: "2px"
    }
  },
  outerLabelAdded: {
    borderColor: "primary.900",
    backgroundColor: "primary.400",
    ':hover, :hover:not([aria-disabled="true"])': {
      backgroundColor: "primary.400",
      borderColor: "primary.900",
      color: "primary.1000"
    },
    color: "primary.1000"
  },
  icon: {
    marginRight: "10px",
    marginLeft: "10px",
    flexShrink: 0,
    color: "primary.800"
  },
  iconAdded: {
    color: "primary.1000"
  },
  label: {
    margin: 0,
    color: "primary.800"
  },
  labelAdded: {
    color: "primary.1000"
  },
  /*
  This checkbox doesn't need to show since it's for a11y screen reader purposes only, the screen reader will
  see the checkbox, the visual user will see the custom multiline chip.
   */
  hiddenCheckbox: {
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0
  }
}, fn = ln("input")(() => ie.hiddenCheckbox);
function dn({
  label: t,
  ariaLabel: a,
  id: o,
  isChecked: e,
  onChange: n,
  disabled: i
}) {
  const [s, u] = Je(!!e), l = s ? zr : Xr, f = Pe(() => ({
    ...ie.outerLabel,
    ...s ? ie.outerLabelAdded : {}
  }), [s]), d = Pe(() => ({
    ...ie.icon,
    ...s ? ie.iconAdded : {}
  }), [s]), p = Pe(() => ({
    ...ie.label,
    ...s ? ie.labelAdded : {}
  }), [s]), g = Rt(
    (m) => {
      n && n(o, t, m.target.checked), u(m.target.checked);
    },
    [n, o, t, u]
  );
  return /* @__PURE__ */ te(
    en,
    {
      "aria-label": a ?? t,
      disabled: i,
      sx: f,
      children: [
        /* @__PURE__ */ E(
          fn,
          {
            defaultChecked: !!e,
            onChange: g,
            type: "checkbox",
            disabled: i
          }
        ),
        /* @__PURE__ */ E(l, { sx: d, "aria-hidden": !0 }),
        /* @__PURE__ */ E(It, { sx: p, children: t })
      ]
    },
    o
  );
}
const nr = {
  chipFieldset: {
    border: 0,
    padding: 0
  },
  chipContainer: {
    listStyleType: "none",
    margin: 0,
    padding: 0
  }
}, mn = ({ children: t, spacing: { inline: a, width: o, ...e } = {}, className: n }) => /* @__PURE__ */ E(
  oe,
  {
    sx: {
      marginBlockEnd: 4,
      display: a ? "inline-block" : "block",
      verticalAlign: "top",
      inlineSize: ({ space: i }) => a && Array.isArray(o) ? o == null ? void 0 : o.map((s) => `calc(${s} - ${i[4]})`) : o,
      ...e
    },
    className: n,
    children: t
  }
), yn = sn({});
function Ma({
  options: t,
  label: a,
  disabled: o,
  value: e,
  setFieldValue: n,
  name: i,
  spacing: s,
  isFormDisabled: u
}) {
  const l = u || o, f = cn(yn), [d, p] = ge.useState(
    (f == null ? void 0 : f[i]) ?? e ?? []
  ), [g] = ge.useState(e ?? []), m = Rt(
    (y, T, D) => {
      let S;
      D ? S = [
        ...d.filter((_) => _.id !== y),
        { id: y, label: T, isRemoved: !1 }
      ] : (S = [...d.filter((_) => _.id !== y)], g.some((_) => _.id === y && !_.isRemoved) && S.push({ id: y, label: T, isRemoved: !0 })), S.sort(), p(S), f[i] = S, n(i, S);
    },
    [f, i, n, d, g]
  );
  return t.length === 0 ? (
    // When no options exist, we shouldn't show any UI components so that we avoid odd empty spacing
    /* @__PURE__ */ E(se, {})
  ) : /* @__PURE__ */ te(mn, { spacing: s, children: [
    a && t.length > 0 && /* @__PURE__ */ E(Qe, { as: "h3", level: 3, tabIndex: -1, children: a }),
    /* @__PURE__ */ te(oe, { as: "fieldset", sx: nr.chipFieldset, children: [
      /* @__PURE__ */ E(Ar, { as: "legend", children: a }),
      /* @__PURE__ */ E(
        oe,
        {
          "aria-busy": t.length === 0,
          as: "ul",
          role: t.length > 0 ? "list" : void 0,
          sx: nr.chipContainer,
          children: t.map((y) => /* @__PURE__ */ E(oe, { as: "li", role: "listitem", children: /* @__PURE__ */ E(
            dn,
            {
              label: y.label,
              isChecked: d ? d.some(
                (T) => T.id === y.id && !T.isRemoved
              ) : !1,
              disabled: l,
              ariaLabel: y.ariaLabel,
              id: y.id,
              onChange: m
            }
          ) }, y.id))
        }
      )
    ] })
  ] });
}
function he() {
}
function pn() {
  return !0;
}
function Ce(t) {
  return !!(t || "").match(/\d/);
}
function ar(t) {
  return t == null;
}
function ir(t) {
  return t.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function hn(t) {
  switch (t) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function gn(t, a, o) {
  var e = hn(o), n = t.search(/[1-9]/);
  return n = n === -1 ? t.length : n, t.substring(0, n) + t.substring(n, t.length).replace(e, "$1" + a);
}
function Mt(t, a) {
  a === void 0 && (a = !0);
  var o = t[0] === "-", e = o && a;
  t = t.replace("-", "");
  var n = t.split("."), i = n[0], s = n[1] || "";
  return {
    beforeDecimal: i,
    afterDecimal: s,
    hasNagation: o,
    addNegation: e
  };
}
function Tn(t) {
  if (!t)
    return t;
  var a = t[0] === "-";
  a && (t = t.substring(1, t.length));
  var o = t.split("."), e = o[0].replace(/^0+/, "") || "0", n = o[1] || "";
  return (a ? "-" : "") + e + (n ? "." + n : "");
}
function Er(t, a, o) {
  for (var e = "", n = o ? "0" : "", i = 0; i <= a - 1; i++)
    e += t[i] || n;
  return e;
}
function or(t, a) {
  return Array(a + 1).join(t);
}
function vn(t) {
  t += "";
  var a = t[0] === "-" ? "-" : "";
  a && (t = t.substring(1));
  var o = t.split(/[eE]/g), e = o[0], n = o[1];
  if (n = Number(n), !n)
    return a + e;
  e = e.replace(".", "");
  var i = 1 + n, s = e.length;
  return i < 0 ? e = "0." + or("0", Math.abs(i)) + e : i >= s ? e = e + or("0", i - s) : e = (e.substring(0, i) || "0") + "." + e.substring(i), a + e;
}
function Dn(t, a, o) {
  if (["", "-"].indexOf(t) !== -1)
    return t;
  var e = t.indexOf(".") !== -1 && a, n = Mt(t), i = n.beforeDecimal, s = n.afterDecimal, u = n.hasNagation, l = parseFloat("0." + (s || "0")), f = s.length <= a ? "0." + s : l.toFixed(a), d = f.split("."), p = i.split("").reverse().reduce(function(T, D, S) {
    return T.length > S ? (Number(T[0]) + Number(D)).toString() + T.substring(1, T.length) : D + T;
  }, d[0]), g = Er(
    d[1] || "",
    Math.min(a, s.length),
    o
  ), m = u ? "-" : "", y = e ? "." : "";
  return "" + m + p + y + g;
}
function lr(t, a) {
  if (t.value = t.value, t !== null) {
    if (t.createTextRange) {
      var o = t.createTextRange();
      return o.move("character", a), o.select(), !0;
    }
    return t.selectionStart || t.selectionStart === 0 ? (t.focus(), t.setSelectionRange(a, a), !0) : (t.focus(), !1);
  }
}
function An(t, a) {
  for (var o = 0, e = 0, n = t.length, i = a.length; t[o] === a[o] && o < n; )
    o++;
  for (; t[n - 1 - e] === a[i - 1 - e] && i - e > o && n - e > o; )
    e++;
  return { start: o, end: n - e };
}
function vt(t, a, o) {
  return Math.min(Math.max(t, a), o);
}
function sr(t) {
  return Math.max(t.selectionStart, t.selectionEnd);
}
function Sn(t) {
  return t || typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function En(t, a) {
  var o = {};
  for (var e in t) Object.prototype.hasOwnProperty.call(t, e) && a.indexOf(e) === -1 && (o[e] = t[e]);
  return o;
}
var _n = {
  displayType: "input",
  decimalSeparator: ".",
  thousandsGroupStyle: "thousand",
  fixedDecimalScale: !1,
  prefix: "",
  suffix: "",
  allowNegative: !0,
  allowEmptyFormatting: !1,
  allowLeadingZeros: !1,
  isNumericString: !1,
  type: "text",
  onValueChange: he,
  onChange: he,
  onKeyDown: he,
  onMouseUp: he,
  onFocus: he,
  onBlur: he,
  isAllowed: pn
}, _r = /* @__PURE__ */ function(t) {
  function a(o) {
    t.call(this, o);
    var e = o.defaultValue;
    this.validateProps();
    var n = this.formatValueProp(e);
    this.state = {
      value: n,
      numAsString: this.removeFormatting(n),
      mounted: !1
    }, this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    }, this.onChange = this.onChange.bind(this), this.onKeyDown = this.onKeyDown.bind(this), this.onMouseUp = this.onMouseUp.bind(this), this.onFocus = this.onFocus.bind(this), this.onBlur = this.onBlur.bind(this);
  }
  return t && (a.__proto__ = t), a.prototype = Object.create(t && t.prototype), a.prototype.constructor = a, a.prototype.componentDidMount = function() {
    this.setState({
      mounted: !0
    });
  }, a.prototype.componentDidUpdate = function(e) {
    this.updateValueIfRequired(e);
  }, a.prototype.componentWillUnmount = function() {
    clearTimeout(this.focusTimeout), clearTimeout(this.caretPositionTimeout);
  }, a.prototype.updateValueIfRequired = function(e) {
    var n = this, i = n.props, s = n.state, u = n.focusedElm, l = s.value, f = s.numAsString;
    if (f === void 0 && (f = ""), e !== i) {
      this.validateProps();
      var d = this.formatNumString(f), p = ar(i.value) ? d : this.formatValueProp(), g = this.removeFormatting(p), m = parseFloat(g), y = parseFloat(f);
      //while typing set state only when float value changes
      ((!isNaN(m) || !isNaN(y)) && m !== y || //can also set state when float value is same and the format props changes
      d !== l || //set state always when not in focus and formatted value is changed
      u === null && p !== l) && this.updateValue({
        formattedValue: p,
        numAsString: g,
        input: u,
        source: "prop",
        event: null
      });
    }
  }, a.prototype.getFloatString = function(e) {
    e === void 0 && (e = "");
    var n = this.props, i = n.decimalScale, s = this.getSeparators(), u = s.decimalSeparator, l = this.getNumberRegex(!0), f = e[0] === "-";
    f && (e = e.replace("-", "")), u && i === 0 && (e = e.split(u)[0]), e = (e.match(l) || []).join("").replace(u, ".");
    var d = e.indexOf(".");
    return d !== -1 && (e = e.substring(0, d) + "." + e.substring(d + 1, e.length).replace(new RegExp(ir(u), "g"), "")), f && (e = "-" + e), e;
  }, a.prototype.getNumberRegex = function(e, n) {
    var i = this.props, s = i.format, u = i.decimalScale, l = i.customNumerals, f = this.getSeparators(), d = f.decimalSeparator;
    return new RegExp(
      "[0-9" + (l ? l.join("") : "") + "]" + (d && u !== 0 && !n && !s ? "|" + ir(d) : ""),
      e ? "g" : void 0
    );
  }, a.prototype.getSeparators = function() {
    var e = this.props, n = e.decimalSeparator, i = this.props, s = i.thousandSeparator, u = i.allowedDecimalSeparators;
    return s === !0 && (s = ","), u || (u = [n, "."]), {
      decimalSeparator: n,
      thousandSeparator: s,
      allowedDecimalSeparators: u
    };
  }, a.prototype.getMaskAtIndex = function(e) {
    var n = this.props, i = n.mask;
    return i === void 0 && (i = " "), typeof i == "string" ? i : i[e] || " ";
  }, a.prototype.getValueObject = function(e, n) {
    var i = parseFloat(n);
    return {
      formattedValue: e,
      value: n,
      floatValue: isNaN(i) ? void 0 : i
    };
  }, a.prototype.validateProps = function() {
    var e = this.props, n = e.mask, i = this.getSeparators(), s = i.decimalSeparator, u = i.thousandSeparator;
    if (s === u)
      throw new Error(`
          Decimal separator can't be same as thousand separator.
          thousandSeparator: ` + u + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
          decimalSeparator: ` + s + ` (default value for decimalSeparator is .)
       `);
    if (n) {
      var l = n === "string" ? n : n.toString();
      if (l.match(/\d/g))
        throw new Error(`
          Mask ` + n + ` should not contain numeric character;
        `);
    }
  }, a.prototype.setPatchedCaretPosition = function(e, n, i) {
    lr(e, n), this.caretPositionTimeout = setTimeout(function() {
      e.value === i && lr(e, n);
    }, 0);
  }, a.prototype.correctCaretPosition = function(e, n, i) {
    var s = this.props, u = s.prefix, l = s.suffix, f = s.format;
    if (e === "")
      return 0;
    if (n = vt(n, 0, e.length), !f) {
      var d = e[0] === "-";
      return vt(n, u.length + (d ? 1 : 0), e.length - l.length);
    }
    if (typeof f == "function" || f[n] === "#" && Ce(e[n]) || f[n - 1] === "#" && Ce(e[n - 1]))
      return n;
    var p = f.indexOf("#"), g = f.lastIndexOf("#");
    n = vt(n, p, g + 1);
    for (var m = f.substring(n, f.length).indexOf("#"), y = n, T = n + (m === -1 ? 0 : m); y > p && (f[y] !== "#" || !Ce(e[y])); )
      y -= 1;
    var D = !Ce(e[T]) || i === "left" && n !== p || n - y < T - n;
    return D ? Ce(e[y]) ? y + 1 : y : T;
  }, a.prototype.getCaretPosition = function(e, n, i) {
    var s = this.props, u = s.format, l = this.state.value, f = this.getNumberRegex(!0), d = (e.match(f) || []).join(""), p = (n.match(f) || []).join(""), g, m;
    for (g = 0, m = 0; m < i; m++) {
      var y = e[m] || "", T = n[g] || "";
      if (!(!y.match(f) && y !== T) && !(y === "0" && T.match(f) && T !== "0" && d.length !== p.length)) {
        for (; y !== n[g] && g < n.length; )
          g++;
        g++;
      }
    }
    return typeof u == "string" && !l && (g = n.length), g = this.correctCaretPosition(n, g), g;
  }, a.prototype.removePrefixAndSuffix = function(e) {
    var n = this.props, i = n.format, s = n.prefix, u = n.suffix;
    if (!i && e) {
      var l = e[0] === "-";
      l && (e = e.substring(1, e.length)), e = s && e.indexOf(s) === 0 ? e.substring(s.length, e.length) : e;
      var f = e.lastIndexOf(u);
      e = u && f !== -1 && f === e.length - u.length ? e.substring(0, f) : e, l && (e = "-" + e);
    }
    return e;
  }, a.prototype.removePatternFormatting = function(e) {
    for (var n = this.props, i = n.format, s = i.split("#").filter(function(m) {
      return m !== "";
    }), u = 0, l = "", f = 0, d = s.length; f <= d; f++) {
      var p = s[f] || "", g = f === d ? e.length : e.indexOf(p, u);
      if (g === -1) {
        l = e;
        break;
      } else
        l += e.substring(u, g), u = g + p.length;
    }
    return (l.match(this.getNumberRegex(!0)) || []).join("");
  }, a.prototype.removeFormatting = function(e) {
    var n = this.props, i = n.format, s = n.removeFormatting;
    return e && (i ? typeof i == "string" ? e = this.removePatternFormatting(e) : typeof s == "function" ? e = s(e) : e = (e.match(this.getNumberRegex(!0)) || []).join("") : (e = this.removePrefixAndSuffix(e), e = this.getFloatString(e)), e);
  }, a.prototype.formatWithPattern = function(e) {
    for (var n = this.props, i = n.format, s = 0, u = i.split(""), l = 0, f = i.length; l < f; l++)
      i[l] === "#" && (u[l] = e[s] || this.getMaskAtIndex(s), s += 1);
    return u.join("");
  }, a.prototype.formatAsNumber = function(e) {
    var n = this.props, i = n.decimalScale, s = n.fixedDecimalScale, u = n.prefix, l = n.suffix, f = n.allowNegative, d = n.thousandsGroupStyle, p = this.getSeparators(), g = p.thousandSeparator, m = p.decimalSeparator, y = e.indexOf(".") !== -1 || i && s, T = Mt(e, f), D = T.beforeDecimal, S = T.afterDecimal, _ = T.addNegation;
    return i !== void 0 && (S = Er(S, i, s)), g && (D = gn(D, g, d)), u && (D = u + D), l && (S = S + l), _ && (D = "-" + D), e = D + (y && m || "") + S, e;
  }, a.prototype.formatNumString = function(e) {
    e === void 0 && (e = "");
    var n = this.props, i = n.format, s = n.allowEmptyFormatting, u = n.customNumerals, l = e;
    if (u && u.length === 10) {
      var f = new RegExp("[" + u.join("") + "]", "g");
      l = e.replace(
        f,
        function(d) {
          return u.indexOf(d).toString();
        }
      );
    }
    return e === "" && !s ? l = "" : e === "-" && !i ? l = "-" : typeof i == "string" ? l = this.formatWithPattern(l) : typeof i == "function" ? l = i(l) : l = this.formatAsNumber(l), l;
  }, a.prototype.formatValueProp = function(e) {
    var n = this.props, i = n.format, s = n.decimalScale, u = n.fixedDecimalScale, l = n.allowEmptyFormatting, f = this.props, d = f.value, p = f.isNumericString;
    d = ar(d) ? e : d;
    var g = !d && d !== 0;
    if (g && l && (d = ""), g && !l)
      return "";
    typeof d == "number" && (d = vn(d), p = !0), d === "Infinity" && p && (d = ""), p && !i && typeof s == "number" && (d = Dn(d, s, u));
    var m = p ? this.formatNumString(d) : this.formatInput(d);
    return m;
  }, a.prototype.formatNegation = function(e) {
    e === void 0 && (e = "");
    var n = this.props, i = n.allowNegative, s = new RegExp("(-)"), u = new RegExp("(-)(.)*(-)"), l = s.test(e), f = u.test(e);
    return e = e.replace(/-/g, ""), l && !f && i && (e = "-" + e), e;
  }, a.prototype.formatInput = function(e) {
    e === void 0 && (e = "");
    var n = this.props, i = n.format;
    return i || (e = this.removePrefixAndSuffix(e), e = this.formatNegation(e)), e = this.removeFormatting(e), this.formatNumString(e);
  }, a.prototype.isCharacterAFormat = function(e, n) {
    var i = this.props, s = i.format, u = i.prefix, l = i.suffix, f = i.decimalScale, d = i.fixedDecimalScale, p = this.getSeparators(), g = p.decimalSeparator;
    return !!(typeof s == "string" && s[e] !== "#" || !s && (e < u.length || e >= n.length - l.length || f && d && n[e] === g));
  }, a.prototype.correctInputValue = function(e, n, i) {
    var s = this, u = this.props, l = u.format, f = u.allowNegative, d = u.prefix, p = u.suffix, g = u.decimalScale, m = this.getSeparators(), y = m.allowedDecimalSeparators, T = m.decimalSeparator, D = this.state.numAsString || "", S = this.selectionBeforeInput, _ = S.selectionStart, L = S.selectionEnd, C = An(n, i), M = C.start, K = C.end;
    if (!l && M === K && y.indexOf(i[_]) !== -1) {
      var z = g === 0 ? "" : T;
      return i.substr(0, _) + z + i.substr(_ + 1, i.length);
    }
    var ve = l ? 0 : d.length, De = n.length - (l ? 0 : p.length);
    if (
      // don't do anything if something got added
      i.length > n.length || // or if the new value is an empty string
      !i.length || // or if nothing has changed, in which case start will be same as end
      M === K || // or in case if whole input is selected and new value is typed
      _ === 0 && L === n.length || // or in case if the whole content is replaced by browser, example (autocomplete)
      M === 0 && K === n.length || // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      _ === ve && L === De
    )
      return i;
    var Fe = n.substr(M, K - M), Y = !![].concat(Fe).find(
      function(N, ne) {
        return s.isCharacterAFormat(ne + M, n);
      }
    );
    if (Y) {
      var Ae = n.substr(M), re = {}, Z = [];
      [].concat(Ae).forEach(function(N, ne) {
        s.isCharacterAFormat(ne + M, n) ? re[ne] = N : ne > Fe.length - 1 && Z.push(N);
      }), Object.keys(re).forEach(function(N) {
        Z.length > N ? Z.splice(N, 0, re[N]) : Z.push(re[N]);
      }), i = n.substr(0, M) + Z.join("");
    }
    if (!l) {
      var xe = this.removeFormatting(i), Se = Mt(
        xe,
        f
      ), ot = Se.beforeDecimal, He = Se.afterDecimal, lt = Se.addNegation, ke = e < i.indexOf(T) + 1;
      if (xe.length < D.length && ke && ot === "" && !parseFloat(He))
        return lt ? "-" : "";
    }
    return i;
  }, a.prototype.updateValue = function(e) {
    var n = e.formattedValue, i = e.input, s = e.setCaretPosition;
    s === void 0 && (s = !0);
    var u = e.source, l = e.event, f = e.numAsString, d = e.caretPos, p = this.props, g = p.onValueChange, m = this.state, y = m.value;
    if (i) {
      if (d === void 0 && s) {
        var T = e.inputValue || i.value, D = sr(i);
        i.value = n, d = this.getCaretPosition(T, n, D);
      }
      i.value = n, s && this.setPatchedCaretPosition(i, d, n);
    }
    f === void 0 && (f = this.removeFormatting(n)), n !== y && (this.setState({ value: n, numAsString: f }), g(this.getValueObject(n, f), { event: l, source: u }));
  }, a.prototype.onChange = function(e) {
    var n = e.target, i = n.value, s = this, u = s.state, l = s.props, f = l.isAllowed, d = u.value || "", p = sr(n);
    i = this.correctInputValue(p, d, i);
    var g = this.formatInput(i) || "", m = this.removeFormatting(g), y = this.getValueObject(g, m), T = f(y);
    T || (g = d), this.updateValue({
      formattedValue: g,
      numAsString: m,
      inputValue: i,
      input: n,
      event: e,
      source: "event"
    }), T && l.onChange(e);
  }, a.prototype.onBlur = function(e) {
    var n = this, i = n.props, s = n.state, u = i.format, l = i.onBlur, f = i.allowLeadingZeros, d = s.numAsString, p = s.value;
    if (this.focusedElm = null, clearTimeout(this.focusTimeout), clearTimeout(this.caretPositionTimeout), !u) {
      isNaN(parseFloat(d)) && (d = ""), f || (d = Tn(d));
      var g = this.formatNumString(d);
      if (g !== p) {
        this.updateValue({
          formattedValue: g,
          numAsString: d,
          input: e.target,
          setCaretPosition: !1,
          event: e,
          source: "event"
        }), l(e);
        return;
      }
    }
    l(e);
  }, a.prototype.onKeyDown = function(e) {
    var n = e.target, i = e.key, s = n.selectionStart, u = n.selectionEnd, l = n.value;
    l === void 0 && (l = "");
    var f, d = this.props, p = d.decimalScale, g = d.fixedDecimalScale, m = d.prefix, y = d.suffix, T = d.format, D = d.onKeyDown, S = p !== void 0 && g, _ = this.getNumberRegex(!1, S), L = new RegExp("-"), C = typeof T == "string";
    if (this.selectionBeforeInput = {
      selectionStart: s,
      selectionEnd: u
    }, i === "ArrowLeft" || i === "Backspace" ? f = s - 1 : i === "ArrowRight" ? f = s + 1 : i === "Delete" && (f = s), f === void 0 || s !== u) {
      D(e);
      return;
    }
    var M = f, K = C ? T.indexOf("#") : m.length, z = C ? T.lastIndexOf("#") + 1 : l.length - y.length;
    if (i === "ArrowLeft" || i === "ArrowRight") {
      var ve = i === "ArrowLeft" ? "left" : "right";
      M = this.correctCaretPosition(l, f, ve);
    } else if (i === "Delete" && !_.test(l[f]) && !L.test(l[f]))
      for (; !_.test(l[M]) && M < z; )
        M++;
    else if (i === "Backspace" && !_.test(l[f])) {
      if (s <= K + 1 && l[0] === "-" && typeof T > "u") {
        var De = l.substring(1);
        this.updateValue({
          formattedValue: De,
          caretPos: M,
          input: n,
          event: e,
          source: "event"
        });
      } else if (!L.test(l[f])) {
        for (; !_.test(l[M - 1]) && M > K; )
          M--;
        M = this.correctCaretPosition(l, M, "left");
      }
    }
    (M !== f || f < K || f > z) && (e.preventDefault(), this.setPatchedCaretPosition(n, M, l)), e.isUnitTestRun && this.setPatchedCaretPosition(n, M, l), D(e);
  }, a.prototype.onMouseUp = function(e) {
    var n = e.target, i = n.selectionStart, s = n.selectionEnd, u = n.value;
    if (u === void 0 && (u = ""), i === s) {
      var l = this.correctCaretPosition(u, i);
      l !== i && this.setPatchedCaretPosition(n, l, u);
    }
    this.props.onMouseUp(e);
  }, a.prototype.onFocus = function(e) {
    var n = this;
    e.persist(), this.focusedElm = e.target, this.focusTimeout = setTimeout(function() {
      var i = e.target, s = i.selectionStart, u = i.selectionEnd, l = i.value;
      l === void 0 && (l = "");
      var f = n.correctCaretPosition(l, s);
      f !== s && !(s === 0 && u === l.length) && n.setPatchedCaretPosition(i, f, l), n.props.onFocus(e);
    }, 0);
  }, a.prototype.render = function() {
    var e = this.props, n = e.type, i = e.displayType, s = e.customInput, u = e.renderText, l = e.getInputRef, f = e.format;
    e.thousandSeparator, e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle, e.decimalScale, e.fixedDecimalScale, e.prefix, e.suffix, e.removeFormatting, e.mask, e.defaultValue, e.isNumericString, e.allowNegative, e.allowEmptyFormatting, e.allowLeadingZeros, e.onValueChange, e.isAllowed, e.customNumerals, e.onChange, e.onKeyDown, e.onMouseUp, e.onFocus, e.onBlur, e.value;
    var d = En(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"]), p = d, g = this.state, m = g.value, y = g.mounted, T = y && Sn(f) ? "numeric" : void 0, D = Object.assign({ inputMode: T }, p, {
      type: n,
      value: m,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });
    if (i === "text")
      return u ? u(m, p) || null : ge.createElement(
        "span",
        Object.assign({}, p, { ref: l }),
        m
      );
    if (s) {
      var S = s;
      return ge.createElement(S, Object.assign({}, D, { ref: l }));
    }
    return ge.createElement("input", Object.assign({}, D, { ref: l }));
  }, a;
}(ge.Component);
_r.defaultProps = _n;
var r = /* @__PURE__ */ ((t) => (t.Daily = "DAILY", t.Hourly = "HOURLY", t.Monthly = "MONTHLY", t.Weekly = "WEEKLY", t.Yearly = "YEARLY", t))(r || {});
const bn = {
  AE: {
    [r.Hourly]: [1, 448],
    [r.Daily]: [1, 3577],
    [r.Weekly]: [1, 17883],
    [r.Monthly]: [1, 74510],
    [r.Yearly]: [1, 894120]
  },
  AQ: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  AR: {
    [r.Hourly]: [1, 300],
    [r.Daily]: [1, 2400],
    [r.Weekly]: [1, 12e3],
    [r.Monthly]: [1, 5e4],
    [r.Yearly]: [1, 6e5]
  },
  AT: {
    [r.Hourly]: [1, 160],
    [r.Daily]: [1, 1227],
    [r.Weekly]: [1, 6132],
    [r.Monthly]: [1, 25550],
    [r.Yearly]: [1, 306600]
  },
  AU: {
    [r.Hourly]: [1, 389],
    [r.Daily]: [1, 3108],
    [r.Weekly]: [1, 15539],
    [r.Monthly]: [1, 64743],
    [r.Yearly]: [1, 776910]
  },
  BE: {
    [r.Hourly]: [1, 188],
    [r.Daily]: [1, 1429],
    [r.Weekly]: [1, 7143],
    [r.Monthly]: [1, 29760],
    [r.Yearly]: [1, 357120]
  },
  BH: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  BR: {
    [r.Hourly]: [1, 128],
    [r.Daily]: [1, 1124],
    [r.Weekly]: [1, 5616],
    [r.Monthly]: [1, 23400],
    [r.Yearly]: [1, 280800]
  },
  CA: {
    [r.Hourly]: [1, 304],
    [r.Daily]: [1, 2426],
    [r.Weekly]: [1, 12130],
    [r.Monthly]: [1, 50540],
    [r.Yearly]: [1, 606470]
  },
  CH: {
    [r.Hourly]: [1, 341],
    [r.Daily]: [1, 2728],
    [r.Weekly]: [1, 13640],
    [r.Monthly]: [1, 56834],
    [r.Yearly]: [1, 682e3]
  },
  CL: {
    [r.Hourly]: [1, 35146],
    [r.Daily]: [1, 281170],
    [r.Weekly]: [1, 1405851],
    [r.Monthly]: [1, 5857714],
    [r.Yearly]: [1, 70292570]
  },
  CN: {
    [r.Hourly]: [1, 372],
    [r.Daily]: [1, 2973],
    [r.Weekly]: [1, 14864],
    [r.Monthly]: [1, 61932],
    [r.Yearly]: [1, 743180]
  },
  CO: {
    [r.Hourly]: [1, 48752],
    [r.Daily]: [1, 390015],
    [r.Weekly]: [1, 2340089],
    [r.Monthly]: [1, 9750370],
    [r.Yearly]: [1, 117004440]
  },
  CR: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  CZ: {
    [r.Hourly]: [1, 1571],
    [r.Daily]: [1, 12568],
    [r.Weekly]: [1, 62840],
    [r.Monthly]: [1, 261833],
    [r.Yearly]: [1, 3141990]
  },
  DE: {
    [r.Hourly]: [1, 270],
    [r.Daily]: [1, 2157],
    [r.Weekly]: [1, 10783],
    [r.Monthly]: [1, 44929],
    [r.Yearly]: [1, 539145]
  },
  DK: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  EC: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  EG: {
    [r.Hourly]: [1, 200],
    [r.Daily]: [1, 1600],
    [r.Weekly]: [1, 8e3],
    [r.Monthly]: [1, 33334],
    [r.Yearly]: [1, 4e5]
  },
  ES: {
    [r.Hourly]: [1, 90],
    [r.Daily]: [1, 720],
    [r.Weekly]: [1, 3600],
    [r.Monthly]: [1, 15e3],
    [r.Yearly]: [1, 18e4]
  },
  FI: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  FR: {
    [r.Hourly]: [1, 204],
    [r.Daily]: [1, 1423],
    [r.Weekly]: [1, 7115],
    [r.Monthly]: [1, 29645],
    [r.Yearly]: [1, 355740]
  },
  GB: {
    [r.Hourly]: [1, 161],
    [r.Daily]: [1, 1288],
    [r.Weekly]: [1, 6438],
    [r.Monthly]: [1, 26824],
    [r.Yearly]: [1, 321880]
  },
  GR: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  HK: {
    [r.Hourly]: [1, 1170],
    [r.Daily]: [1, 9360],
    [r.Weekly]: [1, 46800],
    [r.Monthly]: [1, 195e3],
    [r.Yearly]: [1, 234e4]
  },
  HU: {
    [r.Hourly]: [1, 15614],
    [r.Daily]: [1, 124905],
    [r.Weekly]: [1, 624524],
    [r.Monthly]: [1, 2602180],
    [r.Yearly]: [1, 31226160]
  },
  ID: {
    [r.Hourly]: [1, 45e4],
    [r.Daily]: [1, 36e5],
    [r.Weekly]: [1, 18e6],
    [r.Monthly]: [1, 75e6],
    [r.Yearly]: [1, 9e8]
  },
  IE: {
    [r.Hourly]: [1, 256],
    [r.Daily]: [1, 2047],
    [r.Weekly]: [1, 10232],
    [r.Monthly]: [1, 42632],
    [r.Yearly]: [1, 511580]
  },
  IL: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  IN: {
    [r.Hourly]: [1, 4802],
    [r.Daily]: [1, 38415],
    [r.Weekly]: [1, 230489],
    [r.Monthly]: [1, 960371],
    [r.Yearly]: [1, 11524450]
  },
  IT: {
    [r.Hourly]: [1, 145],
    [r.Daily]: [1, 1157],
    [r.Weekly]: [1, 5784],
    [r.Monthly]: [1, 24100],
    [r.Yearly]: [1, 289190]
  },
  JP: {
    [r.Hourly]: [1, 13911],
    [r.Daily]: [1, 111289],
    [r.Weekly]: [1, 556446],
    [r.Monthly]: [1, 2318526],
    [r.Yearly]: [1, 27822312]
  },
  KR: {
    [r.Hourly]: [1, 194113],
    [r.Daily]: [1, 1552901],
    [r.Weekly]: [1, 7764504],
    [r.Monthly]: [1, 32352100],
    [r.Yearly]: [1, 388225200]
  },
  KW: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  LU: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  MA: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  MX: {
    [r.Hourly]: [1, 514],
    [r.Daily]: [1, 4105],
    [r.Weekly]: [1, 24625],
    [r.Monthly]: [1, 102605],
    [r.Yearly]: [1, 1231250]
  },
  MY: {
    [r.Hourly]: [1, 270],
    [r.Daily]: [1, 2160],
    [r.Weekly]: [1, 10800],
    [r.Monthly]: [1, 45e3],
    [r.Yearly]: [1, 54e4]
  },
  NG: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  NL: {
    [r.Hourly]: [1, 213],
    [r.Daily]: [1, 1700],
    [r.Weekly]: [1, 8499],
    [r.Monthly]: [1, 35410],
    [r.Yearly]: [1, 424910]
  },
  NO: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  NZ: {
    [r.Hourly]: [1, 266],
    [r.Daily]: [1, 2122],
    [r.Weekly]: [1, 10608],
    [r.Monthly]: [1, 44200],
    [r.Yearly]: [1, 530400]
  },
  OM: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  PA: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  PE: {
    [r.Hourly]: [1, 125],
    [r.Daily]: [1, 997],
    [r.Weekly]: [1, 4983],
    [r.Monthly]: [1, 20760],
    [r.Yearly]: [1, 249120]
  },
  PH: {
    [r.Hourly]: [1, 661],
    [r.Daily]: [1, 5285],
    [r.Weekly]: [1, 26424],
    [r.Monthly]: [1, 110100],
    [r.Yearly]: [1, 1321200]
  },
  PK: {
    [r.Hourly]: [1, 749],
    [r.Daily]: [1, 5989],
    [r.Weekly]: [1, 35931],
    [r.Monthly]: [1, 149710],
    [r.Yearly]: [1, 1796520]
  },
  PL: {
    [r.Hourly]: [1, 234],
    [r.Daily]: [1, 1872],
    [r.Weekly]: [1, 9360],
    [r.Monthly]: [1, 39e3],
    [r.Yearly]: [1, 468e3]
  },
  PT: {
    [r.Hourly]: [1, 49],
    [r.Daily]: [1, 387],
    [r.Weekly]: [1, 1935],
    [r.Monthly]: [1, 8060],
    [r.Yearly]: [1, 96720]
  },
  QA: {
    [r.Hourly]: [1, 629],
    [r.Daily]: [1, 5032],
    [r.Weekly]: [1, 25160],
    [r.Monthly]: [1, 104830],
    [r.Yearly]: [1, 1257960]
  },
  RO: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  RU: {
    [r.Hourly]: [1, 1370],
    [r.Daily]: [1, 10958],
    [r.Weekly]: [1, 54787],
    [r.Monthly]: [1, 228277],
    [r.Yearly]: [1, 2739324]
  },
  SA: {
    [r.Hourly]: [1, 305],
    [r.Daily]: [1, 2928],
    [r.Weekly]: [1, 14638],
    [r.Monthly]: [1, 60990],
    [r.Yearly]: [1, 731880]
  },
  SE: {
    [r.Hourly]: [1, 1884],
    [r.Daily]: [1, 15072],
    [r.Weekly]: [1, 75360],
    [r.Monthly]: [1, 314e3],
    [r.Yearly]: [1, 3768e3]
  },
  SG: {
    [r.Hourly]: [1, 294],
    [r.Daily]: [1, 2349],
    [r.Weekly]: [1, 11741],
    [r.Monthly]: [1, 48920],
    [r.Yearly]: [1, 587040]
  },
  TH: {
    [r.Hourly]: [1, 3334],
    [r.Daily]: [1, 26667],
    [r.Weekly]: [1, 16e4],
    [r.Monthly]: [1, 666667],
    [r.Yearly]: [1, 8e6]
  },
  TR: {
    [r.Hourly]: [1, 124],
    [r.Daily]: [1, 1114],
    [r.Weekly]: [1, 5566],
    [r.Monthly]: [1, 23190],
    [r.Yearly]: [1, 278280]
  },
  TW: {
    [r.Hourly]: [1, 2739],
    [r.Daily]: [1, 21909],
    [r.Weekly]: [1, 109541],
    [r.Monthly]: [1, 456420],
    [r.Yearly]: [1, 5477040]
  },
  UA: {
    [r.Hourly]: [1, 600],
    [r.Daily]: [1, 4800],
    [r.Weekly]: [1, 24e3],
    [r.Monthly]: [1, 1e5],
    [r.Yearly]: [1, 12e5]
  },
  US: {
    [r.Hourly]: [2, 500],
    [r.Daily]: [30, 4e3],
    [r.Weekly]: [40, 2e4],
    [r.Monthly]: [100, 83334],
    [r.Yearly]: [2e3, 1e6]
  },
  UY: {
    [r.Hourly]: [1, 5e5],
    [r.Daily]: [1, 4e6],
    [r.Weekly]: [1, 2e7],
    [r.Monthly]: [1, 83333334],
    [r.Yearly]: [1, 1e9]
  },
  VE: {
    [r.Hourly]: [1, 2032],
    [r.Daily]: [1, 16256],
    [r.Weekly]: [1, 81276],
    [r.Monthly]: [1, 338650],
    [r.Yearly]: [1, 4063800]
  },
  VN: {
    [r.Hourly]: [1, 277680],
    [r.Daily]: [1, 2221440],
    [r.Weekly]: [1, 11107200],
    [r.Monthly]: [1, 4628e4],
    [r.Yearly]: [1, 55536e4]
  },
  ZA: {
    [r.Hourly]: [1, 881],
    [r.Daily]: [1, 7929],
    [r.Weekly]: [1, 39641],
    [r.Monthly]: [1, 165170],
    [r.Yearly]: [1, 1982040]
  }
}, br = (t) => ({
  [r.Hourly]: t("per hour"),
  [r.Weekly]: t("per week"),
  [r.Daily]: t("per day"),
  [r.Monthly]: t("per month"),
  [r.Yearly]: t("per year")
}), Ca = (t) => ({
  [r.Hourly]: t.gettext("Hourly"),
  [r.Weekly]: t.gettext("Weekly"),
  [r.Daily]: t.gettext("Daily"),
  [r.Monthly]: t.gettext("Monthly"),
  [r.Yearly]: t.gettext("Yearly")
}), cr = {
  AD: "EUR",
  AE: "AED",
  AF: "AFN",
  AG: "XCD",
  AI: "XCD",
  AL: "ALL",
  AM: "AMD",
  AO: "AOA",
  AQ: "USD",
  AR: "ARS",
  AS: "USD",
  AT: "EUR",
  AU: "AUD",
  AW: "AWG",
  AX: "EUR",
  AZ: "AZN",
  BA: "BAM",
  BB: "BBD",
  BD: "BDT",
  BE: "EUR",
  BF: "XOF",
  BG: "BGN",
  BH: "BHD",
  BI: "BIF",
  BJ: "XOF",
  BL: "EUR",
  BM: "BMD",
  BN: "BND",
  BO: "BOB",
  BQ: "USD",
  BR: "BRL",
  BS: "BSD",
  BT: "BTN",
  BV: "NOK",
  BW: "BWP",
  BY: "BYR",
  BZ: "BZD",
  CA: "CAD",
  CC: "AUD",
  CD: "CDF",
  CF: "XAF",
  CG: "XAF",
  CH: "CHF",
  CI: "XOF",
  CK: "NZD",
  CL: "CLP",
  CM: "XAF",
  CN: "CNY",
  CO: "COP",
  CR: "CRC",
  CU: "CUP",
  CV: "CVE",
  CW: "ANG",
  CX: "AUD",
  CY: "EUR",
  CZ: "CZK",
  DE: "EUR",
  DJ: "DJF",
  DK: "DKK",
  DM: "XCD",
  DO: "DOP",
  DZ: "DZD",
  EC: "USD",
  EE: "EUR",
  EG: "EGP",
  EH: "MAD",
  ER: "ERN",
  ES: "EUR",
  ET: "ETB",
  FI: "EUR",
  FJ: "FJD",
  FK: "FKP",
  FM: "USD",
  FO: "DKK",
  FR: "EUR",
  GA: "XAF",
  GB: "GBP",
  GD: "XCD",
  GE: "GEL",
  GF: "EUR",
  GG: "GBP",
  GH: "GHS",
  GI: "GIP",
  GL: "DKK",
  GM: "GMD",
  GN: "GNF",
  GP: "EUR",
  GQ: "XAF",
  GR: "EUR",
  GS: "GBP",
  GT: "GTQ",
  GU: "USD",
  GW: "XOF",
  GY: "GYD",
  HK: "HKD",
  HM: "AUD",
  HN: "HNL",
  HR: "HRK",
  HT: "HTG",
  HU: "HUF",
  ID: "IDR",
  IE: "EUR",
  IL: "ILS",
  IM: "GBP",
  IN: "INR",
  IO: "USD",
  IQ: "IQD",
  IR: "IRR",
  IS: "ISK",
  IT: "EUR",
  JE: "GBP",
  JM: "JMD",
  JO: "JOD",
  JP: "JPY",
  KE: "KES",
  KG: "KGS",
  KH: "KHR",
  KI: "AUD",
  KM: "KMF",
  KN: "XCD",
  KP: "KPW",
  KR: "KRW",
  KW: "KWD",
  KY: "KYD",
  KZ: "KZT",
  LA: "LAK",
  LB: "LBP",
  LC: "XCD",
  LI: "CHF",
  LK: "LKR",
  LR: "LRD",
  LS: "LSL",
  LT: "LTL",
  LU: "EUR",
  LV: "EUR",
  LY: "LYD",
  MA: "MAD",
  MC: "EUR",
  MD: "MDL",
  ME: "EUR",
  MF: "EUR",
  MG: "MGA",
  MH: "USD",
  MK: "MKD",
  ML: "XOF",
  MM: "MMK",
  MN: "MNT",
  MO: "MOP",
  MP: "USD",
  MQ: "EUR",
  MR: "MRO",
  MS: "XCD",
  MT: "EUR",
  MU: "MUR",
  MV: "MVR",
  MW: "MWK",
  MX: "MXN",
  MY: "MYR",
  MZ: "MZN",
  NA: "NAD",
  NC: "XPF",
  NE: "XOF",
  NF: "AUD",
  NG: "NGN",
  NI: "NIO",
  NL: "EUR",
  NO: "NOK",
  NP: "NPR",
  NR: "AUD",
  NU: "NZD",
  NZ: "NZD",
  OM: "OMR",
  PA: "PAB",
  PE: "PEN",
  PF: "XPF",
  PG: "PGK",
  PH: "PHP",
  PK: "PKR",
  PL: "PLN",
  PM: "EUR",
  PN: "NZD",
  PR: "USD",
  PS: "ILS",
  PT: "EUR",
  PW: "USD",
  PY: "PYG",
  QA: "QAR",
  RE: "EUR",
  RO: "RON",
  RS: "RSD",
  RU: "RUB",
  RW: "RWF",
  SA: "SAR",
  SB: "SBD",
  SC: "SCR",
  SD: "SDG",
  SE: "SEK",
  SG: "SGD",
  SH: "SHP",
  SI: "EUR",
  SJ: "NOK",
  SK: "EUR",
  SL: "SLL",
  SM: "EUR",
  SN: "XOF",
  SO: "SOS",
  SR: "SRD",
  SS: "SSP",
  ST: "STN",
  SV: "USD",
  SX: "ANG",
  SY: "SYP",
  SZ: "SZL",
  TC: "USD",
  TD: "XAF",
  TF: "EUR",
  TG: "XOF",
  TH: "THB",
  TJ: "TJS",
  TK: "NZD",
  TL: "USD",
  TM: "TMT",
  TN: "TND",
  TO: "TOP",
  TR: "TRY",
  TT: "TTD",
  TV: "AUD",
  TW: "TWD",
  TZ: "TZS",
  UA: "UAH",
  UG: "UGX",
  UM: "USD",
  US: "USD",
  UY: "UYU",
  UZ: "UZS",
  VA: "EUR",
  VC: "XCD",
  VE: "VEF",
  VG: "USD",
  VI: "USD",
  VN: "VND",
  VU: "VUV",
  WF: "XPF",
  WS: "WST",
  YE: "YER",
  YT: "EUR",
  ZA: "ZAR",
  ZM: "ZMK",
  ZW: "ZWL"
};
var U = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, le = {}, Mr = {}, tt = {}, Te = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getWindowLocale = t.formatLocale = void 0;
  const a = (e, n) => {
    const i = n ? `-${n}` : "";
    return `${e}${i}`;
  };
  t.formatLocale = a;
  const o = () => {
    const e = window.hl || "en", n = window.co || "";
    return (0, t.formatLocale)(e, n);
  };
  t.getWindowLocale = o;
})(Te);
Object.defineProperty(tt, "__esModule", { value: !0 });
tt.formatNumber = void 0;
const Mn = Te, Cn = (t, a) => {
  let o = (0, Mn.getWindowLocale)();
  try {
    new Intl.NumberFormat(o);
  } catch {
    console.warn(`Invalid locale "${o}", defaulting to "en-US".`), o = "en-US";
  }
  return isNaN(t) || !isFinite(t) ? (console.warn(`Invalid number "${t}", returning "NaN".`), "NaN") : new Intl.NumberFormat(o, a).format(t);
};
tt.formatNumber = Cn;
var rt = {};
Object.defineProperty(rt, "__esModule", { value: !0 });
rt.parseNumber = void 0;
const Nn = Te, Rn = (t, a) => {
  var o, e, n;
  if (!t.trim())
    throw new Error("Input string is empty or blank");
  const i = (0, Nn.getWindowLocale)(), u = new Intl.NumberFormat(i, a).formatToParts(123456789e-2), l = ((o = u.find((y) => y.type === "group")) === null || o === void 0 ? void 0 : o.value) || "", f = ((e = u.find((y) => y.type === "decimal")) === null || e === void 0 ? void 0 : e.value) || ".", d = ((n = u.find((y) => y.type === "currency")) === null || n === void 0 ? void 0 : n.value) || "", p = t.replace(/^[+-]/, "").replace(/[^\d.,-]+$/, "");
  if (/[^\d.,-]/.test(p.replace(new RegExp(`[${d}${l}${f}]`, "g"), "")) || /[+-]/.test(p))
    throw new Error(`Invalid characters in number string: "${t}"`);
  if ((p.match(new RegExp(`[${f}]`, "g")) || []).length > 1)
    throw new Error(`Multiple decimal points in number string: "${t}"`);
  const m = t.replace(new RegExp(`[${d}]`, "g"), "").replace(new RegExp(`[${l}]`, "g"), "").replace(new RegExp(`[${f}]`), ".");
  return parseFloat(m);
};
rt.parseNumber = Rn;
(function(t) {
  var a = U && U.__createBinding || (Object.create ? function(e, n, i, s) {
    s === void 0 && (s = i);
    var u = Object.getOwnPropertyDescriptor(n, i);
    (!u || ("get" in u ? !n.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return n[i];
    } }), Object.defineProperty(e, s, u);
  } : function(e, n, i, s) {
    s === void 0 && (s = i), e[s] = n[i];
  }), o = U && U.__exportStar || function(e, n) {
    for (var i in e) i !== "default" && !Object.prototype.hasOwnProperty.call(n, i) && a(n, e, i);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), o(tt, t), o(rt, t);
})(Mr);
var Cr = {}, Nr = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.convertToMinor = t.convertToMajor = t.getIsSymbolAfter = t.getCurrencyMultiplier = t.getCurrencyDecimals = t.CURRENCY_UNITS_DICT = t.formatCurrency = t.getDisplayCurrency = t.getDisplayCurrencyWithLanguageCountry = t.getDisplayCurrencyWithLocale = void 0;
  const a = Te, o = ["CHF", "CAD"], e = (m, y, T, D, S) => {
    if (m != null && !isNaN(Number(m)))
      if (y) {
        const _ = D ? 2 : 0, L = D ? 2 : 0, C = new Intl.NumberFormat(T, {
          style: "currency",
          currency: y,
          minimumFractionDigits: _,
          maximumFractionDigits: L,
          // @ts-ignore This is introduced in es2020, but current target is es2018
          currencyDisplay: S
        }).format(m);
        return o.indexOf(y) >= 0 ? C : C.replace(/\s/g, "");
      } else
        return `${m}`;
    else
      return "";
  };
  t.getDisplayCurrencyWithLocale = e;
  const n = (m, y, T, D, S, _) => (0, t.getDisplayCurrencyWithLocale)(m, y, (0, a.formatLocale)(T, D), S, _);
  t.getDisplayCurrencyWithLanguageCountry = n;
  const i = (m, y, T, D) => (0, t.getDisplayCurrencyWithLocale)(m, y, (0, a.getWindowLocale)(), T, D);
  t.getDisplayCurrency = i;
  const s = ({ amount: m, currency: y, language: T, countryCode: D = "", locale: S, showDecimalPlaces: _, currencyDisplay: L }) => (_ === void 0 && (_ = l(y) !== 0), T ? (0, t.getDisplayCurrencyWithLanguageCountry)(m, y, T, D, _, L) : S ? (0, t.getDisplayCurrencyWithLocale)(m, y, S, _, L) : (0, t.getDisplayCurrency)(m, y, _, L));
  t.formatCurrency = s, t.CURRENCY_UNITS_DICT = {
    AUD: 2,
    BRL: 2,
    CAD: 2,
    CHF: 2,
    EUR: 2,
    GBP: 2,
    INR: 2,
    JPY: 0,
    MXN: 2,
    SGD: 2,
    USD: 2
  };
  const u = 2;
  function l(m) {
    return m in t.CURRENCY_UNITS_DICT ? t.CURRENCY_UNITS_DICT[m] : u;
  }
  t.getCurrencyDecimals = l;
  function f(m) {
    return Math.pow(10, l(m));
  }
  t.getCurrencyMultiplier = f;
  function d(m) {
    return new Intl.NumberFormat(m, { style: "currency", currency: "USD" }).format(1).charAt(0) === "1";
  }
  t.getIsSymbolAfter = d;
  function p(m, y) {
    return Math.round(m) / f(y);
  }
  t.convertToMajor = p;
  function g(m, y) {
    return Math.round(m * f(y));
  }
  t.convertToMinor = g;
})(Nr);
var Rr = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.clearCache = t.parseCurrency = t.parseCurrencyWithLocale = t.parseCurrencyWithFormatData = t.getFormatData = void 0;
  const a = Te;
  class o {
    constructor(d) {
      var p, g, m, y;
      this.parts = [];
      let T;
      try {
        T = new Intl.NumberFormat(d);
      } catch {
        console.log("Invalid locale format, defaulting to en-US locale"), d = "en-US", T = new Intl.NumberFormat(d);
      }
      if (T.formatToParts)
        this.parts = T.formatToParts(12345.6);
      else {
        const D = T.format(12345.6);
        this.parts = [
          { type: "integer", value: D.substr(0, 2) },
          { type: "group", value: D.substr(2, 1) },
          { type: "integer", value: D.substr(3, 3) },
          { type: "decimal", value: D.substr(6, 1) },
          { type: "fraction", value: D.substr(7) }
        ];
      }
      this.numerals = [
        ...new Intl.NumberFormat(d, { useGrouping: !1 }).format(9876543210)
      ].reverse(), this.numeralMap = new Map(this.numerals.map((D, S) => [D, S])), this.group = new RegExp(`[${(g = (p = this.parts.find((D) => D.type === "group")) === null || p === void 0 ? void 0 : p.value) !== null && g !== void 0 ? g : ""}]`, "g"), this.decimal = new RegExp(`[${(y = (m = this.parts.find((D) => D.type === "decimal")) === null || m === void 0 ? void 0 : m.value) !== null && y !== void 0 ? y : ""}]`), this.numeral = new RegExp(`[${this.numerals.join("")}]`, "g"), this.index = (D) => {
        var S, _;
        return (_ = (S = this.numeralMap.get(D)) === null || S === void 0 ? void 0 : S.toString()) !== null && _ !== void 0 ? _ : "";
      };
    }
  }
  let e = {};
  const n = (f) => {
    let d = e[f];
    return d || (d = new o(f), e[f] = d), d;
  };
  t.getFormatData = n;
  const i = (f, d) => {
    const p = f.replace(/\s+/g, "").replace(d.group, "").replace(d.decimal, ".").replace(d.numeral, d.index);
    return Number(p);
  };
  t.parseCurrencyWithFormatData = i;
  const s = (f, d) => {
    const p = (0, t.getFormatData)(d);
    return (0, t.parseCurrencyWithFormatData)(f, p);
  };
  t.parseCurrencyWithLocale = s;
  const u = (f, d = "") => {
    let p = (0, a.getWindowLocale)();
    d.toLowerCase() === "chf" && p.indexOf("fr") !== 0 && (p = "fr-FR");
    const g = (0, t.getFormatData)(p);
    return (0, t.parseCurrencyWithFormatData)(f, g);
  };
  t.parseCurrency = u;
  const l = () => {
    e = {};
  };
  t.clearCache = l;
})(Rr);
(function(t) {
  var a = U && U.__createBinding || (Object.create ? function(e, n, i, s) {
    s === void 0 && (s = i);
    var u = Object.getOwnPropertyDescriptor(n, i);
    (!u || ("get" in u ? !n.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return n[i];
    } }), Object.defineProperty(e, s, u);
  } : function(e, n, i, s) {
    s === void 0 && (s = i), e[s] = n[i];
  }), o = U && U.__exportStar || function(e, n) {
    for (var i in e) i !== "default" && !Object.prototype.hasOwnProperty.call(n, i) && a(n, e, i);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), o(Nr, t), o(Rr, t);
})(Cr);
var Ir = {}, nt = {};
Object.defineProperty(nt, "__esModule", { value: !0 });
nt.formatDate = void 0;
const In = Te, Ln = (t, ...a) => {
  let o = {};
  (typeof t == "number" || typeof t == "string") && (t = new Date(t)), a.length === 2 && (o = a.pop());
  let e = (0, In.getWindowLocale)();
  return a.length === 1 && (typeof a[0] == "string" ? e = a[0].replace("_", "-") : typeof a[0] == "object" && (o = a[0])), t.toLocaleDateString(e, o);
};
nt.formatDate = Ln;
var Ot = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getDateTypeFormatIndexes = t.getDateTypeFormatForLocale = t.DateTypeFormat = t.formatsByLocale = void 0, t.formatsByLocale = {
    DD_MM_YYYY: [
      "en-AE",
      "en-AU",
      "en-IE",
      "en-IN",
      "en-NZ",
      "en-SG",
      "es-CL",
      "nl",
      "nl-NL",
      "pt-PT",
      "da",
      "da-DK",
      "de",
      "de-AT",
      "de-BE",
      "de-CH",
      "de-DE",
      "de-LU",
      "en-BE",
      "en-CH",
      "en-IL",
      "en-LU",
      "fi",
      "fi-FI",
      "fr-BE",
      "fr-CH",
      "fr-LU",
      "he",
      "he-IL",
      "it-CH",
      "nl-BE",
      "no",
      "no-NO",
      "pl",
      "ro",
      "ro-RO",
      "ru-UA",
      "ru-RU",
      "tr",
      "uk-UA",
      "ar",
      "ar-SA",
      "ar-EG",
      "el",
      "el-GR",
      "en-BH",
      "en-EG",
      "en-GB",
      "en-HK",
      "en-KW",
      "en-NG",
      "en-OM",
      "en-QA",
      "en-SA",
      "en-TH",
      "es-AR",
      "es-CO",
      "es-CR",
      "es-EC",
      "es-ES",
      "es-MX",
      "es-PA",
      "es-PE",
      "es-UY",
      "es-VE",
      "fr-FR",
      "fr-MA",
      "en-MA",
      "in",
      "it",
      "ms",
      "pt-BR",
      "th"
    ],
    MM_DD_YYYY: ["en-ID", "en-MY", "en-PH", "en-US"],
    YYYY_MM_DD: [
      "en-CA",
      "en-VN",
      "en-ZA",
      "fr-CA",
      "sv",
      "sv-SE",
      "vi",
      "ko",
      "hu",
      "hu-HU",
      "ja",
      "zh",
      "zh-HK",
      "zh-SG",
      "zh-TW"
    ]
  };
  var a;
  (function(n) {
    n.DD_MM_YYYY = "DD_MM_YYYY", n.MM_DD_YYYY = "MM_DD_YYYY", n.YYYY_MM_DD = "YYYY_MM_DD";
  })(a = t.DateTypeFormat || (t.DateTypeFormat = {}));
  const o = (n) => (n = n.replace("_", "-"), t.formatsByLocale.MM_DD_YYYY.includes(n) ? a.MM_DD_YYYY : t.formatsByLocale.YYYY_MM_DD.includes(n) ? a.YYYY_MM_DD : (t.formatsByLocale.DD_MM_YYYY.includes(n), a.DD_MM_YYYY));
  t.getDateTypeFormatForLocale = o;
  const e = (n) => {
    switch (n) {
      case a.MM_DD_YYYY:
        return {
          dateType: a.MM_DD_YYYY,
          dayIndex: 1,
          monthIndex: 0,
          yearIndex: 2
        };
      case a.YYYY_MM_DD:
        return {
          dateType: a.YYYY_MM_DD,
          dayIndex: 2,
          monthIndex: 1,
          yearIndex: 0
        };
      case a.DD_MM_YYYY:
        return {
          dateType: a.DD_MM_YYYY,
          dayIndex: 0,
          monthIndex: 1,
          yearIndex: 2
        };
    }
  };
  t.getDateTypeFormatIndexes = e;
})(Ot);
var Lr = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.parseLocalizedDate = t.convertCalendarDigitsToDate = void 0;
  const a = Ot, o = (i, s) => {
    const u = i.split(/[-\/年月日]|[(\.\s)]|[(\.)]/).filter((S) => !!S);
    if (u.length < 3)
      return;
    const { yearIndex: l, monthIndex: f, dayIndex: d } = (0, a.getDateTypeFormatIndexes)(s), p = u[d].trim(), g = u[f].trim(), m = u[l].trim();
    if (p.length > 2 || g.length > 2 || m.length > 4 || m.length <= 2)
      return;
    const y = parseInt(p, 10), T = parseInt(g, 10), D = parseInt(m, 10);
    if (!(y > 31 || y < 1 || T > 12 || T < 1 || D < 0))
      return {
        day: y,
        month: T,
        year: D
      };
  }, e = (i) => {
    const { day: s, month: u, year: l } = i;
    return new Date(l, u - 1, s);
  };
  t.convertCalendarDigitsToDate = e;
  const n = (i, s) => {
    const u = o(i, s);
    return u ? (0, t.convertCalendarDigitsToDate)(u) : void 0;
  };
  t.parseLocalizedDate = n;
})(Lr);
(function(t) {
  var a = U && U.__createBinding || (Object.create ? function(e, n, i, s) {
    s === void 0 && (s = i);
    var u = Object.getOwnPropertyDescriptor(n, i);
    (!u || ("get" in u ? !n.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return n[i];
    } }), Object.defineProperty(e, s, u);
  } : function(e, n, i, s) {
    s === void 0 && (s = i), e[s] = n[i];
  }), o = U && U.__exportStar || function(e, n) {
    for (var i in e) i !== "default" && !Object.prototype.hasOwnProperty.call(n, i) && a(n, e, i);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), o(nt, t), o(Ot, t), o(Lr, t);
})(Ir);
var On = U && U.__createBinding || (Object.create ? function(t, a, o, e) {
  e === void 0 && (e = o);
  var n = Object.getOwnPropertyDescriptor(a, o);
  (!n || ("get" in n ? !a.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
    return a[o];
  } }), Object.defineProperty(t, e, n);
} : function(t, a, o, e) {
  e === void 0 && (e = o), t[e] = a[o];
}), Pn = U && U.__setModuleDefault || (Object.create ? function(t, a) {
  Object.defineProperty(t, "default", { enumerable: !0, value: a });
} : function(t, a) {
  t.default = a;
}), Pt = U && U.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var a = {};
  if (t != null) for (var o in t) o !== "default" && Object.prototype.hasOwnProperty.call(t, o) && On(a, t, o);
  return Pn(a, t), a;
};
Object.defineProperty(le, "__esModule", { value: !0 });
le.DateUtils = we = le.CurrencyUtils = le.NumberUtils = void 0;
const wn = Pt(Mr);
le.NumberUtils = wn;
const Un = Pt(Cr);
var we = le.CurrencyUtils = Un;
const Yn = Pt(Ir);
le.DateUtils = Yn;
function Or(t) {
  var a;
  try {
    const o = ((a = t.match(/\w\w$/)) == null ? void 0 : a[0]) ?? "US", e = cr[o] ?? "USD", n = we.formatCurrency({
      amount: 0,
      showDecimalPlaces: !1,
      currency: e,
      locale: t
    }).replace("0", ""), i = we.getIsSymbolAfter(t);
    return {
      hasRighthandSymbol: typeof i == "boolean" && i,
      currencySymbol: n,
      currencyCode: e
    };
  } catch {
    return {
      hasRighthandSymbol: !1,
      currencySymbol: "$",
      currencyCode: cr.US
    };
  }
}
function Na(t, a) {
  let o;
  try {
    o = we.parseCurrencyWithLocale(t || "0", a);
  } catch {
    try {
      o = we.parseCurrencyWithLocale(t || "0", "en-US");
    } catch {
      o = Number.NaN;
    }
  }
  return o;
}
const Fn = (t, a, o, e) => {
  const n = Number(t.amount), i = t.type, [s, u] = bn[o][i] || [0, Number.MAX_SAFE_INTEGER], l = br(e), f = { style: "decimal" };
  if (n && i) {
    const { currencySymbol: d } = Or(a);
    if (n <= s)
      return e("Add a pay higher than {0}{1} {2}, or adjust the pay period.", [
        d,
        s.toLocaleString(a, f),
        l[i]
      ]);
    if (n >= u)
      return e("Add a pay lower than {0}{1} {2}, or adjust the pay period.", [
        d,
        u.toLocaleString(a, f),
        l[i]
      ]);
  }
}, xn = (t, a) => (a ? [
  r.Hourly,
  r.Yearly,
  r.Monthly,
  r.Weekly,
  r.Daily
] : [
  r.Hourly,
  r.Daily,
  r.Weekly,
  r.Monthly,
  r.Yearly
]).map((e) => ({
  label: t[e],
  value: e
})), Hn = ({
  label: t = "",
  helperText: a,
  errorText: o = "",
  required: e,
  value: n = "",
  hiddenLabel: i,
  placeholder: s,
  sx: u,
  contentAfter: l,
  hasError: f,
  refToFocus: d,
  isFormDisabled: p,
  ...g
}) => {
  const m = f || o.length > 0, y = p && !m;
  return /* @__PURE__ */ E(
    et,
    {
      label: i ? void 0 : t,
      helperText: a,
      errorText: o,
      errorTextId: `${g.id}-errorText`,
      showRequiredIndicator: !!e,
      invalid: m,
      htmlFor: g.id,
      disabled: y,
      children: /* @__PURE__ */ E(
        tn,
        {
          "aria-label": i ? t : void 0,
          ...g,
          "aria-required": !!e,
          value: n,
          ref: d,
          placeholder: s,
          sx: u,
          invalid: m,
          contentAfter: l,
          disabled: y,
          "aria-describedby": g["aria-describedby"] || `${g.id}-errorText`
        }
      )
    }
  );
}, kn = ({
  value: t,
  required: a,
  error: o,
  invalid: e,
  max: n,
  label: i,
  showPayAccuracyError: s,
  ...u
}) => {
  const l = Lt(), { currencySymbol: f, hasRighthandSymbol: d } = Pe(
    () => {
      const m = l.locale.toString();
      return Or(m);
    },
    [l]
  ), p = /* @__PURE__ */ E(It, { variant: "secondary", level: 3, children: f }), g = i || l.gettext("Minimum base pay");
  return /* @__PURE__ */ E(
    et,
    {
      label: g,
      showRequiredIndicator: !!a,
      invalid: e,
      children: /* @__PURE__ */ E(
        _r,
        {
          ...u,
          name: u.id,
          contentBefore: !d && p,
          contentAfter: d && p,
          thousandSeparator: s ? "," : void 0,
          required: !!a,
          defaultValue: t,
          value: t,
          "aria-label": l.gettext("{0}, Amount, {1}", [g, f]),
          customInput: Hn,
          min: "0",
          step: ".01",
          isAllowed: (m) => {
            const y = Number.parseInt(m.value, 10);
            return y && n ? y <= n : !0;
          },
          inputMode: "decimal",
          errorText: o,
          "data-testid": `${u.id}-input`,
          onValueChange: (m) => {
            u.setFieldValue(u.name, m.value);
          }
        }
      )
    }
  );
}, Wn = ({
  value: t,
  error: a,
  required: o,
  invalid: e,
  refToFocus: n,
  usePayPeriodChips: i = !1,
  label: s,
  setFieldValue: u,
  ...l
}) => {
  const f = Lt(), [d, p] = Je(!1), g = Pe(() => br(f.gettext), [f]), m = xn(g, i), y = s || f.gettext("Pay period");
  return i ? /* @__PURE__ */ te(oe, { children: [
    /* @__PURE__ */ E(
      rn,
      {
        id: `periodselect-${l.name}`,
        label: y,
        invalid: !!e,
        size: "md",
        errorText: a,
        showRequiredIndicator: o,
        "aria-describedby": l["aria-describedby"],
        items: m.slice(0, d ? void 0 : 2).map((T) => ({
          ...T,
          checked: T.value === t,
          label: `${T.label[0].toUpperCase()}${T.label.slice(1)}`,
          onChange: () => {
            u(l.name, T.value);
          }
        }))
      }
    ),
    /* @__PURE__ */ E(
      nn,
      {
        variant: "text",
        type: "button",
        onClick: () => p(!d),
        iconAfter: d ? /* @__PURE__ */ E(Zr, { "aria-hidden": !0 }) : /* @__PURE__ */ E(qr, { "aria-hidden": !0 }),
        children: d ? f.gettext("Show less pay periods") : f.gettext("Show more pay periods")
      }
    )
  ] }) : /* @__PURE__ */ E(
    an,
    {
      label: y,
      invalid: e,
      errorText: a,
      selectRef: n,
      showRequiredIndicator: o,
      options: [{
        value: "",
        label: f.pgettext("Select placeholder", "Select")
      }, ...m],
      selectProps: {
        "aria-required": !!o,
        "data-testid": `${l.id}-select`,
        sx: {
          select: {
            margin: 0
          }
        },
        value: t,
        "aria-describedby": l["aria-describedby"],
        "aria-label": f.gettext("{0}, Type", [y]),
        onChange: (T) => {
          u(l.name, T.target.value);
        }
      }
    }
  );
};
function Ra({
  error: t,
  payLabel: a,
  periodLabel: o,
  value: e,
  setFieldValue: n,
  required: i,
  disclaimer: s,
  id: u,
  autofocus: l,
  reversePayInputs: f = !1,
  isReAsk: d = !1,
  ...p
}) {
  const [g, m] = Je(d), y = Lt(), T = !!(t != null && t.all) && g, D = {
    amount: (e == null ? void 0 : e.amount) || "",
    type: (e == null ? void 0 : e.type) || ""
  }, S = `${p.name}-errorText`, _ = s || y.gettext("Not shown to employers."), L = /* @__PURE__ */ E(
    kn,
    {
      id: `payinput-${u}-${p.name}`,
      value: D.amount,
      required: !!i,
      error: t == null ? void 0 : t.amount,
      invalid: !!(t != null && t.amount || T),
      "aria-describedby": T ? S : void 0,
      autoFocus: l && !!(t != null && t.amount),
      ...p,
      label: a,
      onBlur: () => {
        m(!0);
      },
      setFieldValue: (K, z) => {
        n(p.name, {
          ...e,
          amount: z
        });
      }
    },
    "pay"
  ), C = /* @__PURE__ */ Vr(
    Wn,
    {
      ...p,
      key: "select",
      id: `periodselect-${u}-${p.name}`,
      name: "type",
      required: !!i,
      value: D.type,
      error: t == null ? void 0 : t.type,
      invalid: !!(t != null && t.type || T),
      "aria-describedby": T ? S : void 0,
      autofocus: l && !!(t != null && t.type) && !(t != null && t.amount),
      setFieldValue: (K, z) => {
        n(p.name, {
          ...e,
          type: z
        });
      },
      label: o
    }
  ), M = f ? [C, L] : [L, C];
  return /* @__PURE__ */ te(et, { as: "fieldset", errorText: t == null ? void 0 : t.all, invalid: T, errorTextId: S, children: [
    /* @__PURE__ */ E(Ar, { as: "legend", children: p["aria-label"] }),
    /* @__PURE__ */ te(
      oe,
      {
        sx: {
          display: "flex",
          flexDirection: "column",
          gap: 4
        },
        children: [
          y.locale.toString() !== "ja-JP" && _ && /* @__PURE__ */ E(Sr, { icon: /* @__PURE__ */ E(Dr, { color: "background.status.info", "aria-hidden": !0 }), status: "info", children: _ }),
          M
        ]
      }
    )
  ] });
}
var Bn = /* @__PURE__ */ ((t) => (t.LightBulb = "lightbulb", t.Car = "car", t))(Bn || {});
const Gn = ({ icon: t }) => /* @__PURE__ */ te(se, { children: [
  t === "car" && /* @__PURE__ */ E(Jr, { "data-testid": "car-icon" }),
  t === "lightbulb" && /* @__PURE__ */ E(Qr, { "data-testid": "light-bulb-icon" })
] }), Ia = ({
  label: t,
  icon: a = "lightbulb"
  /* LightBulb */
}) => /* @__PURE__ */ te(
  on,
  {
    sx: {
      backgroundColor: "expressive.aqua.100",
      color: "expressive.aqua.800",
      padding: 4,
      borderRadius: "md",
      gap: 2
    },
    children: [
      /* @__PURE__ */ E(Gn, { icon: a }),
      /* @__PURE__ */ E(
        It,
        {
          as: "p",
          level: 3,
          sx: {
            margin: 0,
            color: "expressive.aqua.800"
          },
          children: t
        }
      )
    ]
  }
);
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const {
  entries: Pr,
  setPrototypeOf: ur,
  isFrozen: Kn,
  getPrototypeOf: jn,
  getOwnPropertyDescriptor: $n
} = Object;
let {
  freeze: B,
  seal: $,
  create: wr
} = Object, {
  apply: Ct,
  construct: Nt
} = typeof Reflect < "u" && Reflect;
B || (B = function(a) {
  return a;
});
$ || ($ = function(a) {
  return a;
});
Ct || (Ct = function(a, o, e) {
  return a.apply(o, e);
});
Nt || (Nt = function(a, o) {
  return new a(...o);
});
const ze = G(Array.prototype.forEach), Vn = G(Array.prototype.lastIndexOf), fr = G(Array.prototype.pop), Ne = G(Array.prototype.push), zn = G(Array.prototype.splice), Ze = G(String.prototype.toLowerCase), Dt = G(String.prototype.toString), dr = G(String.prototype.match), Re = G(String.prototype.replace), Xn = G(String.prototype.indexOf), Zn = G(String.prototype.trim), V = G(Object.prototype.hasOwnProperty), W = G(RegExp.prototype.test), Ie = qn(TypeError);
function G(t) {
  return function(a) {
    a instanceof RegExp && (a.lastIndex = 0);
    for (var o = arguments.length, e = new Array(o > 1 ? o - 1 : 0), n = 1; n < o; n++)
      e[n - 1] = arguments[n];
    return Ct(t, a, e);
  };
}
function qn(t) {
  return function() {
    for (var a = arguments.length, o = new Array(a), e = 0; e < a; e++)
      o[e] = arguments[e];
    return Nt(t, o);
  };
}
function b(t, a) {
  let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ze;
  ur && ur(t, null);
  let e = a.length;
  for (; e--; ) {
    let n = a[e];
    if (typeof n == "string") {
      const i = o(n);
      i !== n && (Kn(a) || (a[e] = i), n = i);
    }
    t[n] = !0;
  }
  return t;
}
function Jn(t) {
  for (let a = 0; a < t.length; a++)
    V(t, a) || (t[a] = null);
  return t;
}
function ee(t) {
  const a = wr(null);
  for (const [o, e] of Pr(t))
    V(t, o) && (Array.isArray(e) ? a[o] = Jn(e) : e && typeof e == "object" && e.constructor === Object ? a[o] = ee(e) : a[o] = e);
  return a;
}
function Le(t, a) {
  for (; t !== null; ) {
    const e = $n(t, a);
    if (e) {
      if (e.get)
        return G(e.get);
      if (typeof e.value == "function")
        return G(e.value);
    }
    t = jn(t);
  }
  function o() {
    return null;
  }
  return o;
}
const mr = B(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), At = B(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), St = B(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Qn = B(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Et = B(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), ea = B(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), yr = B(["#text"]), pr = B(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), _t = B(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), hr = B(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Xe = B(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ta = $(/\{\{[\w\W]*|[\w\W]*\}\}/gm), ra = $(/<%[\w\W]*|[\w\W]*%>/gm), na = $(/\$\{[\w\W]*/gm), aa = $(/^data-[\-\w.\u00B7-\uFFFF]+$/), ia = $(/^aria-[\-\w]+$/), Ur = $(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), oa = $(/^(?:\w+script|data):/i), la = $(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Yr = $(/^html$/i), sa = $(/^[a-z][.\w]*(-[.\w]+)+$/i);
var gr = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: ia,
  ATTR_WHITESPACE: la,
  CUSTOM_ELEMENT: sa,
  DATA_ATTR: aa,
  DOCTYPE_NAME: Yr,
  ERB_EXPR: ra,
  IS_ALLOWED_URI: Ur,
  IS_SCRIPT_OR_DATA: oa,
  MUSTACHE_EXPR: ta,
  TMPLIT_EXPR: na
});
const Oe = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, ca = function() {
  return typeof window > "u" ? null : window;
}, ua = function(a, o) {
  if (typeof a != "object" || typeof a.createPolicy != "function")
    return null;
  let e = null;
  const n = "data-tt-policy-suffix";
  o && o.hasAttribute(n) && (e = o.getAttribute(n));
  const i = "dompurify" + (e ? "#" + e : "");
  try {
    return a.createPolicy(i, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, Tr = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Fr() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ca();
  const a = (A) => Fr(A);
  if (a.version = "3.2.6", a.removed = [], !t || !t.document || t.document.nodeType !== Oe.document || !t.Element)
    return a.isSupported = !1, a;
  let {
    document: o
  } = t;
  const e = o, n = e.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: s,
    Node: u,
    Element: l,
    NodeFilter: f,
    NamedNodeMap: d = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: p,
    DOMParser: g,
    trustedTypes: m
  } = t, y = l.prototype, T = Le(y, "cloneNode"), D = Le(y, "remove"), S = Le(y, "nextSibling"), _ = Le(y, "childNodes"), L = Le(y, "parentNode");
  if (typeof s == "function") {
    const A = o.createElement("template");
    A.content && A.content.ownerDocument && (o = A.content.ownerDocument);
  }
  let C, M = "";
  const {
    implementation: K,
    createNodeIterator: z,
    createDocumentFragment: ve,
    getElementsByTagName: De
  } = o, {
    importNode: Fe
  } = e;
  let Y = Tr();
  a.isSupported = typeof Pr == "function" && typeof L == "function" && K && K.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Ae,
    ERB_EXPR: re,
    TMPLIT_EXPR: Z,
    DATA_ATTR: xe,
    ARIA_ATTR: Se,
    IS_SCRIPT_OR_DATA: ot,
    ATTR_WHITESPACE: He,
    CUSTOM_ELEMENT: lt
  } = gr;
  let {
    IS_ALLOWED_URI: ke
  } = gr, N = null;
  const ne = b({}, [...mr, ...At, ...St, ...Et, ...yr]);
  let F = null;
  const Ut = b({}, [...pr, ..._t, ...hr, ...Xe]);
  let O = Object.seal(wr(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Ee = null, st = null, Yt = !0, ct = !0, Ft = !1, xt = !0, ce = !1, We = !0, ae = !1, ut = !1, ft = !1, ue = !1, Be = !1, Ge = !1, Ht = !0, kt = !1;
  const Hr = "user-content-";
  let dt = !0, _e = !1, fe = {}, de = null;
  const Wt = b({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Bt = null;
  const Gt = b({}, ["audio", "video", "img", "source", "image", "track"]);
  let mt = null;
  const Kt = b({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Ke = "http://www.w3.org/1998/Math/MathML", je = "http://www.w3.org/2000/svg", q = "http://www.w3.org/1999/xhtml";
  let me = q, yt = !1, pt = null;
  const kr = b({}, [Ke, je, q], Dt);
  let $e = b({}, ["mi", "mo", "mn", "ms", "mtext"]), Ve = b({}, ["annotation-xml"]);
  const Wr = b({}, ["title", "style", "font", "a", "script"]);
  let be = null;
  const Br = ["application/xhtml+xml", "text/html"], Gr = "text/html";
  let w = null, ye = null;
  const Kr = o.createElement("form"), jt = function(c) {
    return c instanceof RegExp || c instanceof Function;
  }, ht = function() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(ye && ye === c)) {
      if ((!c || typeof c != "object") && (c = {}), c = ee(c), be = // eslint-disable-next-line unicorn/prefer-includes
      Br.indexOf(c.PARSER_MEDIA_TYPE) === -1 ? Gr : c.PARSER_MEDIA_TYPE, w = be === "application/xhtml+xml" ? Dt : Ze, N = V(c, "ALLOWED_TAGS") ? b({}, c.ALLOWED_TAGS, w) : ne, F = V(c, "ALLOWED_ATTR") ? b({}, c.ALLOWED_ATTR, w) : Ut, pt = V(c, "ALLOWED_NAMESPACES") ? b({}, c.ALLOWED_NAMESPACES, Dt) : kr, mt = V(c, "ADD_URI_SAFE_ATTR") ? b(ee(Kt), c.ADD_URI_SAFE_ATTR, w) : Kt, Bt = V(c, "ADD_DATA_URI_TAGS") ? b(ee(Gt), c.ADD_DATA_URI_TAGS, w) : Gt, de = V(c, "FORBID_CONTENTS") ? b({}, c.FORBID_CONTENTS, w) : Wt, Ee = V(c, "FORBID_TAGS") ? b({}, c.FORBID_TAGS, w) : ee({}), st = V(c, "FORBID_ATTR") ? b({}, c.FORBID_ATTR, w) : ee({}), fe = V(c, "USE_PROFILES") ? c.USE_PROFILES : !1, Yt = c.ALLOW_ARIA_ATTR !== !1, ct = c.ALLOW_DATA_ATTR !== !1, Ft = c.ALLOW_UNKNOWN_PROTOCOLS || !1, xt = c.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ce = c.SAFE_FOR_TEMPLATES || !1, We = c.SAFE_FOR_XML !== !1, ae = c.WHOLE_DOCUMENT || !1, ue = c.RETURN_DOM || !1, Be = c.RETURN_DOM_FRAGMENT || !1, Ge = c.RETURN_TRUSTED_TYPE || !1, ft = c.FORCE_BODY || !1, Ht = c.SANITIZE_DOM !== !1, kt = c.SANITIZE_NAMED_PROPS || !1, dt = c.KEEP_CONTENT !== !1, _e = c.IN_PLACE || !1, ke = c.ALLOWED_URI_REGEXP || Ur, me = c.NAMESPACE || q, $e = c.MATHML_TEXT_INTEGRATION_POINTS || $e, Ve = c.HTML_INTEGRATION_POINTS || Ve, O = c.CUSTOM_ELEMENT_HANDLING || {}, c.CUSTOM_ELEMENT_HANDLING && jt(c.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (O.tagNameCheck = c.CUSTOM_ELEMENT_HANDLING.tagNameCheck), c.CUSTOM_ELEMENT_HANDLING && jt(c.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (O.attributeNameCheck = c.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), c.CUSTOM_ELEMENT_HANDLING && typeof c.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (O.allowCustomizedBuiltInElements = c.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ce && (ct = !1), Be && (ue = !0), fe && (N = b({}, yr), F = [], fe.html === !0 && (b(N, mr), b(F, pr)), fe.svg === !0 && (b(N, At), b(F, _t), b(F, Xe)), fe.svgFilters === !0 && (b(N, St), b(F, _t), b(F, Xe)), fe.mathMl === !0 && (b(N, Et), b(F, hr), b(F, Xe))), c.ADD_TAGS && (N === ne && (N = ee(N)), b(N, c.ADD_TAGS, w)), c.ADD_ATTR && (F === Ut && (F = ee(F)), b(F, c.ADD_ATTR, w)), c.ADD_URI_SAFE_ATTR && b(mt, c.ADD_URI_SAFE_ATTR, w), c.FORBID_CONTENTS && (de === Wt && (de = ee(de)), b(de, c.FORBID_CONTENTS, w)), dt && (N["#text"] = !0), ae && b(N, ["html", "head", "body"]), N.table && (b(N, ["tbody"]), delete Ee.tbody), c.TRUSTED_TYPES_POLICY) {
        if (typeof c.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Ie('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof c.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Ie('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        C = c.TRUSTED_TYPES_POLICY, M = C.createHTML("");
      } else
        C === void 0 && (C = ua(m, n)), C !== null && typeof M == "string" && (M = C.createHTML(""));
      B && B(c), ye = c;
    }
  }, $t = b({}, [...At, ...St, ...Qn]), Vt = b({}, [...Et, ...ea]), jr = function(c) {
    let h = L(c);
    (!h || !h.tagName) && (h = {
      namespaceURI: me,
      tagName: "template"
    });
    const v = Ze(c.tagName), I = Ze(h.tagName);
    return pt[c.namespaceURI] ? c.namespaceURI === je ? h.namespaceURI === q ? v === "svg" : h.namespaceURI === Ke ? v === "svg" && (I === "annotation-xml" || $e[I]) : !!$t[v] : c.namespaceURI === Ke ? h.namespaceURI === q ? v === "math" : h.namespaceURI === je ? v === "math" && Ve[I] : !!Vt[v] : c.namespaceURI === q ? h.namespaceURI === je && !Ve[I] || h.namespaceURI === Ke && !$e[I] ? !1 : !Vt[v] && (Wr[v] || !$t[v]) : !!(be === "application/xhtml+xml" && pt[c.namespaceURI]) : !1;
  }, X = function(c) {
    Ne(a.removed, {
      element: c
    });
    try {
      L(c).removeChild(c);
    } catch {
      D(c);
    }
  }, pe = function(c, h) {
    try {
      Ne(a.removed, {
        attribute: h.getAttributeNode(c),
        from: h
      });
    } catch {
      Ne(a.removed, {
        attribute: null,
        from: h
      });
    }
    if (h.removeAttribute(c), c === "is")
      if (ue || Be)
        try {
          X(h);
        } catch {
        }
      else
        try {
          h.setAttribute(c, "");
        } catch {
        }
  }, zt = function(c) {
    let h = null, v = null;
    if (ft)
      c = "<remove></remove>" + c;
    else {
      const P = dr(c, /^[\r\n\t ]+/);
      v = P && P[0];
    }
    be === "application/xhtml+xml" && me === q && (c = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + c + "</body></html>");
    const I = C ? C.createHTML(c) : c;
    if (me === q)
      try {
        h = new g().parseFromString(I, be);
      } catch {
      }
    if (!h || !h.documentElement) {
      h = K.createDocument(me, "template", null);
      try {
        h.documentElement.innerHTML = yt ? M : I;
      } catch {
      }
    }
    const H = h.body || h.documentElement;
    return c && v && H.insertBefore(o.createTextNode(v), H.childNodes[0] || null), me === q ? De.call(h, ae ? "html" : "body")[0] : ae ? h.documentElement : H;
  }, Xt = function(c) {
    return z.call(
      c.ownerDocument || c,
      c,
      // eslint-disable-next-line no-bitwise
      f.SHOW_ELEMENT | f.SHOW_COMMENT | f.SHOW_TEXT | f.SHOW_PROCESSING_INSTRUCTION | f.SHOW_CDATA_SECTION,
      null
    );
  }, gt = function(c) {
    return c instanceof p && (typeof c.nodeName != "string" || typeof c.textContent != "string" || typeof c.removeChild != "function" || !(c.attributes instanceof d) || typeof c.removeAttribute != "function" || typeof c.setAttribute != "function" || typeof c.namespaceURI != "string" || typeof c.insertBefore != "function" || typeof c.hasChildNodes != "function");
  }, Zt = function(c) {
    return typeof u == "function" && c instanceof u;
  };
  function J(A, c, h) {
    ze(A, (v) => {
      v.call(a, c, h, ye);
    });
  }
  const qt = function(c) {
    let h = null;
    if (J(Y.beforeSanitizeElements, c, null), gt(c))
      return X(c), !0;
    const v = w(c.nodeName);
    if (J(Y.uponSanitizeElement, c, {
      tagName: v,
      allowedTags: N
    }), We && c.hasChildNodes() && !Zt(c.firstElementChild) && W(/<[/\w!]/g, c.innerHTML) && W(/<[/\w!]/g, c.textContent) || c.nodeType === Oe.progressingInstruction || We && c.nodeType === Oe.comment && W(/<[/\w]/g, c.data))
      return X(c), !0;
    if (!N[v] || Ee[v]) {
      if (!Ee[v] && Qt(v) && (O.tagNameCheck instanceof RegExp && W(O.tagNameCheck, v) || O.tagNameCheck instanceof Function && O.tagNameCheck(v)))
        return !1;
      if (dt && !de[v]) {
        const I = L(c) || c.parentNode, H = _(c) || c.childNodes;
        if (H && I) {
          const P = H.length;
          for (let j = P - 1; j >= 0; --j) {
            const Q = T(H[j], !0);
            Q.__removalCount = (c.__removalCount || 0) + 1, I.insertBefore(Q, S(c));
          }
        }
      }
      return X(c), !0;
    }
    return c instanceof l && !jr(c) || (v === "noscript" || v === "noembed" || v === "noframes") && W(/<\/no(script|embed|frames)/i, c.innerHTML) ? (X(c), !0) : (ce && c.nodeType === Oe.text && (h = c.textContent, ze([Ae, re, Z], (I) => {
      h = Re(h, I, " ");
    }), c.textContent !== h && (Ne(a.removed, {
      element: c.cloneNode()
    }), c.textContent = h)), J(Y.afterSanitizeElements, c, null), !1);
  }, Jt = function(c, h, v) {
    if (Ht && (h === "id" || h === "name") && (v in o || v in Kr))
      return !1;
    if (!(ct && !st[h] && W(xe, h))) {
      if (!(Yt && W(Se, h))) {
        if (!F[h] || st[h]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Qt(c) && (O.tagNameCheck instanceof RegExp && W(O.tagNameCheck, c) || O.tagNameCheck instanceof Function && O.tagNameCheck(c)) && (O.attributeNameCheck instanceof RegExp && W(O.attributeNameCheck, h) || O.attributeNameCheck instanceof Function && O.attributeNameCheck(h)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            h === "is" && O.allowCustomizedBuiltInElements && (O.tagNameCheck instanceof RegExp && W(O.tagNameCheck, v) || O.tagNameCheck instanceof Function && O.tagNameCheck(v)))
          ) return !1;
        } else if (!mt[h]) {
          if (!W(ke, Re(v, He, ""))) {
            if (!((h === "src" || h === "xlink:href" || h === "href") && c !== "script" && Xn(v, "data:") === 0 && Bt[c])) {
              if (!(Ft && !W(ot, Re(v, He, "")))) {
                if (v)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Qt = function(c) {
    return c !== "annotation-xml" && dr(c, lt);
  }, er = function(c) {
    J(Y.beforeSanitizeAttributes, c, null);
    const {
      attributes: h
    } = c;
    if (!h || gt(c))
      return;
    const v = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: F,
      forceKeepAttr: void 0
    };
    let I = h.length;
    for (; I--; ) {
      const H = h[I], {
        name: P,
        namespaceURI: j,
        value: Q
      } = H, Me = w(P), Tt = Q;
      let k = P === "value" ? Tt : Zn(Tt);
      if (v.attrName = Me, v.attrValue = k, v.keepAttr = !0, v.forceKeepAttr = void 0, J(Y.uponSanitizeAttribute, c, v), k = v.attrValue, kt && (Me === "id" || Me === "name") && (pe(P, c), k = Hr + k), We && W(/((--!?|])>)|<\/(style|title)/i, k)) {
        pe(P, c);
        continue;
      }
      if (v.forceKeepAttr)
        continue;
      if (!v.keepAttr) {
        pe(P, c);
        continue;
      }
      if (!xt && W(/\/>/i, k)) {
        pe(P, c);
        continue;
      }
      ce && ze([Ae, re, Z], (rr) => {
        k = Re(k, rr, " ");
      });
      const tr = w(c.nodeName);
      if (!Jt(tr, Me, k)) {
        pe(P, c);
        continue;
      }
      if (C && typeof m == "object" && typeof m.getAttributeType == "function" && !j)
        switch (m.getAttributeType(tr, Me)) {
          case "TrustedHTML": {
            k = C.createHTML(k);
            break;
          }
          case "TrustedScriptURL": {
            k = C.createScriptURL(k);
            break;
          }
        }
      if (k !== Tt)
        try {
          j ? c.setAttributeNS(j, P, k) : c.setAttribute(P, k), gt(c) ? X(c) : fr(a.removed);
        } catch {
          pe(P, c);
        }
    }
    J(Y.afterSanitizeAttributes, c, null);
  }, $r = function A(c) {
    let h = null;
    const v = Xt(c);
    for (J(Y.beforeSanitizeShadowDOM, c, null); h = v.nextNode(); )
      J(Y.uponSanitizeShadowNode, h, null), qt(h), er(h), h.content instanceof i && A(h.content);
    J(Y.afterSanitizeShadowDOM, c, null);
  };
  return a.sanitize = function(A) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, h = null, v = null, I = null, H = null;
    if (yt = !A, yt && (A = "<!-->"), typeof A != "string" && !Zt(A))
      if (typeof A.toString == "function") {
        if (A = A.toString(), typeof A != "string")
          throw Ie("dirty is not a string, aborting");
      } else
        throw Ie("toString is not a function");
    if (!a.isSupported)
      return A;
    if (ut || ht(c), a.removed = [], typeof A == "string" && (_e = !1), _e) {
      if (A.nodeName) {
        const Q = w(A.nodeName);
        if (!N[Q] || Ee[Q])
          throw Ie("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (A instanceof u)
      h = zt("<!---->"), v = h.ownerDocument.importNode(A, !0), v.nodeType === Oe.element && v.nodeName === "BODY" || v.nodeName === "HTML" ? h = v : h.appendChild(v);
    else {
      if (!ue && !ce && !ae && // eslint-disable-next-line unicorn/prefer-includes
      A.indexOf("<") === -1)
        return C && Ge ? C.createHTML(A) : A;
      if (h = zt(A), !h)
        return ue ? null : Ge ? M : "";
    }
    h && ft && X(h.firstChild);
    const P = Xt(_e ? A : h);
    for (; I = P.nextNode(); )
      qt(I), er(I), I.content instanceof i && $r(I.content);
    if (_e)
      return A;
    if (ue) {
      if (Be)
        for (H = ve.call(h.ownerDocument); h.firstChild; )
          H.appendChild(h.firstChild);
      else
        H = h;
      return (F.shadowroot || F.shadowrootmode) && (H = Fe.call(e, H, !0)), H;
    }
    let j = ae ? h.outerHTML : h.innerHTML;
    return ae && N["!doctype"] && h.ownerDocument && h.ownerDocument.doctype && h.ownerDocument.doctype.name && W(Yr, h.ownerDocument.doctype.name) && (j = "<!DOCTYPE " + h.ownerDocument.doctype.name + `>
` + j), ce && ze([Ae, re, Z], (Q) => {
      j = Re(j, Q, " ");
    }), C && Ge ? C.createHTML(j) : j;
  }, a.setConfig = function() {
    let A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ht(A), ut = !0;
  }, a.clearConfig = function() {
    ye = null, ut = !1;
  }, a.isValidAttribute = function(A, c, h) {
    ye || ht({});
    const v = w(A), I = w(c);
    return Jt(v, I, h);
  }, a.addHook = function(A, c) {
    typeof c == "function" && Ne(Y[A], c);
  }, a.removeHook = function(A, c) {
    if (c !== void 0) {
      const h = Vn(Y[A], c);
      return h === -1 ? void 0 : zn(Y[A], h, 1)[0];
    }
    return fr(Y[A]);
  }, a.removeHooks = function(A) {
    Y[A] = [];
  }, a.removeAllHooks = function() {
    Y = Tr();
  }, a;
}
var fa = Fr();
const { sanitize: da } = fa, La = ({ label: t, sx: a, ...o }) => /* @__PURE__ */ E(
  Qe,
  {
    level: 4,
    as: "h3",
    sx: { fontWeight: "normal", margin: 0, ...a },
    "data-testid": t,
    dangerouslySetInnerHTML: { __html: da(t) },
    ...o
  }
);
var xr = {}, wt = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.ImmutableCoordinate = t.MIN_LONGITUDE = t.MAX_LONGITUDE = t.MIN_LATITUDE = t.MAX_LATITUDE = void 0, t.MAX_LATITUDE = 90, t.MIN_LATITUDE = -90, t.MAX_LONGITUDE = 180, t.MIN_LONGITUDE = -180;
  class a {
    constructor(e, n) {
      if (!isFinite(e) || !isFinite(n))
        throw RangeError("Latitude and longitude must be finite numbers");
      if (e > t.MAX_LATITUDE)
        throw RangeError(`Latitude must be less than or equal to ${t.MAX_LATITUDE}`);
      if (e < t.MIN_LATITUDE)
        throw RangeError(`Latitude must be greater than or equal to ${t.MIN_LATITUDE}`);
      if (n > t.MAX_LONGITUDE)
        throw RangeError(`Longitude must be less than or equal to ${t.MAX_LATITUDE}`);
      if (n < t.MIN_LONGITUDE)
        throw RangeError(`Longitude must be greater than or equal to ${t.MIN_LATITUDE}`);
      this.latitude = e, this.longitude = n;
    }
  }
  t.ImmutableCoordinate = a;
})(wt);
var Ue = {}, Ye = {}, at = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.isPlaceType = t.isAdminType = t.getAdmin = t.getPrecisionKilometers = t.LocationType = void 0;
  var a;
  (function(l) {
    l[l.COUNTRY = 0] = "COUNTRY", l[l.ADMIN1 = 1] = "ADMIN1", l[l.ADMIN2 = 2] = "ADMIN2", l[l.ADMIN3 = 3] = "ADMIN3", l[l.ADMIN4 = 4] = "ADMIN4", l[l.CITY = 5] = "CITY", l[l.POSTAL_CODE = 6] = "POSTAL_CODE", l[l.STATION = 7] = "STATION", l[l.AIRPORT = 8] = "AIRPORT", l[l.WATER = 9] = "WATER", l[l.POSTAL_PLACE = 10] = "POSTAL_PLACE", l[l.MISC = 11] = "MISC", l[l.PRECISE_LOCATION = 12] = "PRECISE_LOCATION";
  })(a = t.LocationType || (t.LocationType = {}));
  const o = {
    [a.COUNTRY]: {
      defaultPrecisionKilometers: 2300,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !1
    },
    [a.ADMIN1]: {
      defaultPrecisionKilometers: 360,
      countryPrecisionKilometers: {},
      isAdminType: !0,
      isPlaceType: !1
    },
    [a.ADMIN2]: {
      defaultPrecisionKilometers: 90,
      countryPrecisionKilometers: {},
      isAdminType: !0,
      isPlaceType: !1
    },
    [a.ADMIN3]: {
      defaultPrecisionKilometers: 90,
      countryPrecisionKilometers: {},
      isAdminType: !0,
      isPlaceType: !1
    },
    [a.ADMIN4]: {
      defaultPrecisionKilometers: 5,
      countryPrecisionKilometers: {},
      isAdminType: !0,
      isPlaceType: !1
    },
    [a.CITY]: {
      defaultPrecisionKilometers: 5,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !0
    },
    [a.POSTAL_CODE]: {
      defaultPrecisionKilometers: 2,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !1
    },
    [a.STATION]: {
      defaultPrecisionKilometers: 5,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !0
    },
    [a.AIRPORT]: {
      defaultPrecisionKilometers: 5,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !0
    },
    [a.WATER]: {
      defaultPrecisionKilometers: 5,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !0
    },
    [a.POSTAL_PLACE]: {
      defaultPrecisionKilometers: 5,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !0
    },
    [a.MISC]: {
      defaultPrecisionKilometers: 5,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !0
    },
    [a.PRECISE_LOCATION]: {
      defaultPrecisionKilometers: 0.2,
      countryPrecisionKilometers: {},
      isAdminType: !1,
      isPlaceType: !0
    }
  }, e = /* @__PURE__ */ new Map([
    [1, a.ADMIN1],
    [2, a.ADMIN2],
    [3, a.ADMIN3],
    [4, a.ADMIN4]
  ]);
  function n(l, f) {
    const d = o[l];
    return d.countryPrecisionKilometers[f] || d.defaultPrecisionKilometers;
  }
  t.getPrecisionKilometers = n;
  function i(l) {
    const f = e.get(l);
    if (f === void 0)
      throw RangeError(`Bad admin value: ${l}; value must be in the range of 1 to 4`);
    return f;
  }
  t.getAdmin = i;
  function s(l) {
    return o[l].isAdminType;
  }
  t.isAdminType = s;
  function u(l) {
    return o[l].isPlaceType;
  }
  t.isPlaceType = u;
})(at);
Object.defineProperty(Ye, "__esModule", { value: !0 });
Ye.ImmutableStructuredLocation = void 0;
const R = at;
class x {
  constructor(a, o, e) {
    if (typeof e > "u" && a !== R.LocationType.COUNTRY)
      throw Error("Non-COUNTRY types are required to have a parent");
    if (o.length === 0)
      throw Error("Location code can't be a blank string");
    this.parent = e, this.type = a, this.code = o;
  }
  getCountryCode() {
    return this.getAncestorCode(R.LocationType.COUNTRY);
  }
  getAdmin1Code() {
    return this.getAncestorCode(R.LocationType.ADMIN1);
  }
  getAdmin2Code() {
    return this.getAncestorCode(R.LocationType.ADMIN2);
  }
  getAdmin3Code() {
    return this.getAncestorCode(R.LocationType.ADMIN3);
  }
  getAdmin4Code() {
    return this.getAncestorCode(R.LocationType.ADMIN4);
  }
  getCityCode() {
    const a = this.getAncestorByFilter((o) => o.type !== R.LocationType.PRECISE_LOCATION && (0, R.isPlaceType)(o.type));
    return typeof a > "u" ? null : a.code;
  }
  getPostalCode() {
    return this.getAncestorCode(R.LocationType.POSTAL_CODE);
  }
  getPreciseLocationCode() {
    return this.getAncestorCode(R.LocationType.PRECISE_LOCATION);
  }
  /**
   * Get the code for the ancestor of the given location type.
   *
   * @param type the location type of the ancestor to get the code for
   * @return the code for the ancestor with the given location type
   */
  getAncestorCode(a) {
    const o = this.getAncestor(a);
    return typeof o > "u" ? null : o.code;
  }
  /**
   * Get the ancestor of this location with the given location type.
   *
   * @param type the location type of the ancestor to get
   * @return the ancestor of this location with the given location type, or undefined if no ancestor has the given
   * location type
   */
  getAncestor(a) {
    return this.getAncestorByFilter((o) => o.type === a);
  }
  /**
   * Get the first ancestor of this location that passes the given filter.
   *
   * @param filter the filter to use to check the location hierarchy
   * @return the first ancestor of this location that passes the given filter, or undefined if no ancestor passes the
   * given filter
   */
  getAncestorByFilter(a) {
    let o = this;
    for (; o !== void 0 && !a(o); )
      o = o.parent;
    return o;
  }
  /**
   * Convenience constructor to create a structured location with 4 admin levels, a city, a postal code, and a precise location.
   *
   * @param countryCode the country code to use for the location
   * @param admin1Code  the admin1 code to use for the location
   * @param admin2Code  the admin2 code to use for the location
   * @param admin3Code  the admin3 code to use for the location
   * @param admin4Code  the admin4 code to use for the location
   * @param cityCode    the city code to use for the location
   * @param postalCode  the postal code to use for the location
   * @param preciseLocation the precise location to use for the location
   * @return the structured location
   */
  static createStructuredLocation(a, o, e, n, i, s, u, l) {
    let f = new x(R.LocationType.COUNTRY, a);
    return typeof o == "string" && o.length > 0 && (f = new x(R.LocationType.ADMIN1, o, f)), typeof e == "string" && e.length > 0 && (f = new x(R.LocationType.ADMIN2, e, f)), typeof n == "string" && n.length > 0 && (f = new x(R.LocationType.ADMIN3, n, f)), typeof i == "string" && i.length > 0 && (f = new x(R.LocationType.ADMIN4, i, f)), typeof s == "string" && s.length > 0 && (f = new x(R.LocationType.CITY, s, f)), typeof u == "string" && u.length > 0 && (f = new x(R.LocationType.POSTAL_CODE, u, f)), typeof l == "string" && l.length > 0 && (f = new x(R.LocationType.PRECISE_LOCATION, l, f)), f;
  }
  /**
   * @deprecated Deprecated in favor of createStructuredLocation
   * Convenience constructor to create a structured location with 4 admin levels, a city, and a postal code.
   *
   * @param countryCode the country code to use for the location
   * @param admin1Code  the admin1 code to use for the location
   * @param admin2Code  the admin2 code to use for the location
   * @param admin3Code  the admin3 code to use for the location
   * @param admin4Code  the admin4 code to use for the location
   * @param cityCode    the city code to use for the location
   * @param postalCode  the postal code to use for the location
   * @return the structured location
   */
  static ofAdmins(a, o, e, n, i, s, u) {
    let l = new x(R.LocationType.COUNTRY, a);
    return typeof o == "string" && o.length > 0 && (l = new x(R.LocationType.ADMIN1, o, l)), typeof e == "string" && e.length > 0 && (l = new x(R.LocationType.ADMIN2, e, l)), typeof n == "string" && n.length > 0 && (l = new x(R.LocationType.ADMIN3, n, l)), typeof i == "string" && i.length > 0 && (l = new x(R.LocationType.ADMIN4, i, l)), typeof s == "string" && s.length > 0 && (l = new x(R.LocationType.CITY, s, l)), typeof u == "string" && u.length > 0 && (l = new x(R.LocationType.POSTAL_CODE, u, l)), l;
  }
}
Ye.ImmutableStructuredLocation = x;
Object.defineProperty(Ue, "__esModule", { value: !0 });
Ue.ImmutableCoordinateStructuredLocation = void 0;
const vr = Ye, bt = at, ma = wt;
class qe extends vr.ImmutableStructuredLocation {
  constructor(a, o, e, n, i, s) {
    if (super(a, o, i), typeof s > "u") {
      const u = this.getCountryCode();
      if (u === null)
        throw new Error("No country code!");
      this.locationPrecisionKilometers = (0, bt.getPrecisionKilometers)(this.type, u);
    } else
      this.locationPrecisionKilometers = s;
    this.coordinate = new ma.ImmutableCoordinate(e, n);
  }
  get latitude() {
    return this.coordinate.latitude;
  }
  get longitude() {
    return this.coordinate.longitude;
  }
  getPreciseLocationCode() {
    return this.getAncestorCode(bt.LocationType.PRECISE_LOCATION);
  }
  /**
   * Convenience constructor to create a coordinate structured location with 4 admin levels, a city, a postal code
   * and a precise location.
   *
   * @param latitude    the latitude of the location
   * @param longitude   the longitude of the location
   * @param countryCode the country code to use for the location
   * @param admin1Code  the admin1 code to use for the location
   * @param admin2Code  the admin2 code to use for the location
   * @param admin3Code  the admin3 code to use for the location
   * @param admin4Code  the admin4 code to use for the location
   * @param cityCode    the city code to use for the location
   * @param postalCode  the postal code to use for the location
   * @param preciseLocation a string representing a precise location - this could be a street address or a precise postal code
   *                        and must not be null or empty if the location's lat/lon are to be considered precise
   * @param locationPrecisionKilometers the location precision in kilometers
   * @return the coordinate structured location
   */
  static of(a, o, e, n, i, s, u, l, f, d, p) {
    const g = vr.ImmutableStructuredLocation.ofAdmins(e, n, i, s, u, l, f);
    return typeof d == "string" && d.length > 0 ? new qe(bt.LocationType.PRECISE_LOCATION, d, a, o, g, p) : new qe(g.type, g.code, a, o, g.parent, p);
  }
}
Ue.ImmutableCoordinateStructuredLocation = qe;
var it = {};
Object.defineProperty(it, "__esModule", { value: !0 });
it.ImmutableNamedLocation = void 0;
const ya = Ue;
class pa extends ya.ImmutableCoordinateStructuredLocation {
  constructor(a, o, e, n, i, s, u, l) {
    if (super(a, o, e, n, u, l), i.length === 0)
      throw Error("Canonical name can't be a blank string");
    this.canonicalName = i, this.aliases = s ?? /* @__PURE__ */ new Map();
  }
}
it.ImmutableNamedLocation = pa;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.ImmutableStructuredLocation = t.ImmutableNamedLocation = t.ImmutableCoordinateStructuredLocation = t.ImmutableCoordinate = t.LocationType = void 0;
  const a = wt;
  Object.defineProperty(t, "ImmutableCoordinate", { enumerable: !0, get: function() {
    return a.ImmutableCoordinate;
  } });
  const o = Ue;
  Object.defineProperty(t, "ImmutableCoordinateStructuredLocation", { enumerable: !0, get: function() {
    return o.ImmutableCoordinateStructuredLocation;
  } });
  const e = at;
  Object.defineProperty(t, "LocationType", { enumerable: !0, get: function() {
    return e.LocationType;
  } });
  const n = it;
  Object.defineProperty(t, "ImmutableNamedLocation", { enumerable: !0, get: function() {
    return n.ImmutableNamedLocation;
  } });
  const i = Ye;
  Object.defineProperty(t, "ImmutableStructuredLocation", { enumerable: !0, get: function() {
    return i.ImmutableStructuredLocation;
  } });
})(xr);
const Oa = ({ filter: t = [xr.LocationType.POSTAL_CODE], label: a = "", country: o, language: e, ...n }) => {
  const [i, s] = Je(void 0), u = (n == null ? void 0 : n.error) !== void 0 ? {
    "span:before": {
      borderColor: "border.status.critical.strong"
    }
  } : void 0, l = i !== void 0 || n == null ? void 0 : n.error;
  return /* @__PURE__ */ E(
    et,
    {
      as: "fieldset",
      errorText: l,
      invalid: (n == null ? void 0 : n.error) !== void 0,
      errorTextId: `${n.id}-errorText`,
      sx: u,
      children: /* @__PURE__ */ E(oe, { children: /* @__PURE__ */ E(
        un,
        {
          options: {
            country: o,
            language: e,
            locationTypeFilter: t
          },
          onValueSelected: (f) => {
            n.setFieldValue(n.name, f);
          },
          preciseLocation: !1,
          ...n,
          label: a,
          onLocationError: s
        }
      ) })
    }
  );
}, Pa = ({ name: t, setFieldValue: a, value: o, options: e, renderOption: n, answerLimit: i, getLabel: s }) => {
  const u = Rt(
    (d) => {
      var T, D;
      const g = ((T = d == null ? void 0 : d.target) == null ? void 0 : T.type) === "checkbox" ? (D = d == null ? void 0 : d.target) == null ? void 0 : D.id : d, m = o.findIndex((S) => s(S) === g);
      if (m != -1) {
        const S = o.filter((_, L) => L !== m);
        a(t, S);
      } else {
        const S = e.find((_) => s(_) == g);
        a(t, [...o, S]);
      }
    },
    [t, a, o, s, e]
  );
  if (!o)
    return /* @__PURE__ */ E(se, {});
  const l = i !== void 0 && o.length >= i, f = i !== void 0 ? Math.max(0, i - o.length) : void 0;
  return /* @__PURE__ */ E(se, { children: e.map((d) => {
    const p = s(d), g = !!o.find((m) => s(m) === p);
    return n({
      label: p,
      isChecked: g,
      onChange: u,
      limitState: {
        isAtLimit: l,
        remainingSelections: f
      }
    });
  }) });
}, wa = ({
  headerText: t,
  headerStyles: a,
  helperText: o,
  helperStyles: e,
  alertLabel: n,
  alertIcon: i,
  alertStyle: s
}) => /* @__PURE__ */ te(se, { children: [
  /* @__PURE__ */ E(ga, { alertIcon: i, alertLabel: n, alertStyle: s }),
  /* @__PURE__ */ E(
    Qe,
    {
      sx: {
        marginBlockEnd: "0",
        color: "foreground.strong",
        ...a
      },
      "data-testid": t,
      level: 3,
      children: t
    }
  ),
  /* @__PURE__ */ E(
    ha,
    {
      helperText: o,
      helperStyles: e
    }
  )
] }), ha = ({
  helperText: t,
  helperStyles: a
}) => t ? /* @__PURE__ */ E(
  Qe,
  {
    sx: {
      fontWeight: 400,
      color: "foreground",
      ...a
    },
    level: 2,
    children: t
  }
) : /* @__PURE__ */ E(se, {}), ga = ({
  alertLabel: t,
  alertIcon: a,
  alertStyle: o
}) => !t && !a ? /* @__PURE__ */ E(se, {}) : /* @__PURE__ */ E(
  Sr,
  {
    icon: ((n) => {
      switch (n) {
        case "hide":
          return /* @__PURE__ */ E(Dr, { size: "md", variant: "stroke", title: "Hide", "aria-hidden": !0 });
        default:
          return;
      }
    })(a),
    status: "info",
    sx: {
      backgroundColor: "background.primary.weak",
      color: "foreground.strong",
      paddingBlockStart: "0.625rem",
      paddingBlockEnd: "0.625rem",
      paddingInlineStart: "1rem",
      borderRadius: "lg",
      borderWidth: 0,
      marginBlockEnd: "1.25rem",
      ...o
    },
    children: t
  }
), Ua = ({
  viewSchema: t,
  dataSchema: a,
  country: o,
  displayProps: e,
  featureFlags: n,
  i18n: i
}) => {
  const { gettext: s, locale: u } = i, l = s("What is the minimum pay you'll consider in your search?");
  return {
    additionalValidation: ({ minimumPaySelector: f }) => {
      if (!(n != null && n.shouldShowPayAccuracyError))
        return {};
      const d = Fn(f, u ?? "", o, s);
      return d ? { minimumPaySelector: { all: d } } : {};
    },
    viewSchema: t || {
      id: "minimumPay",
      editable: {
        view: "standard",
        fields: [
          {
            id: "desiredSalaryHeading",
            renderAs: "title",
            label: l
          },
          (e == null ? void 0 : e.isReAsk) && {
            id: "sentiment",
            entityPath: ["value", "sentiment"],
            options: {
              POSITIVE: s("Yes"),
              NEGATIVE: s("No")
            },
            renderAs: "radio",
            "aria-label": l,
            hasBorder: !0,
            inline: !0
          },
          {
            id: "minimumPaySelector",
            entityPath: {
              amount: ["minimumPaySelector", "amount"],
              type: ["minimumPaySelector", "type"],
              all: ["minimumPaySelector", "all"]
            },
            renderAs: "paySelector",
            payLabel: s("Minimum base pay"),
            disclaimer: s("Not shown to employers."),
            periodlabel: s("Pay period"),
            isReAsk: e == null ? void 0 : e.isReAsk,
            conditions: [
              (e == null ? void 0 : e.isReAsk) && {
                id: "sentiment",
                type: "const",
                value: "NEGATIVE"
              }
            ].filter(Boolean),
            usePayPeriodChips: !0,
            showPayAccuracyError: !0
          },
          e != null && e.salaryRangesForJobQuery ? {
            id: "salaryInsight",
            renderAs: "salaryInsight",
            displayProps: e,
            entityPath: {
              type: ["minimumPaySelector", "type"]
            },
            country: o,
            jobTitle: e.jobTitle,
            salaryRanges: JSON.parse(e.salaryRangesForJobQuery),
            location: e.salaryRangeLocation,
            locale: u
          } : null,
          {
            id: "guidanceBox",
            renderAs: "guidanceBox",
            label: s("We'll show jobs that pay around and above this amount.")
          }
        ].filter(Boolean)
      }
    },
    dataSchema: a || {
      $id: "minimumPayQuestion",
      $schema: "http://json-schema.org/draft-07/schema#",
      description: "Desired minimum pay question",
      type: "object",
      properties: {
        minimumPaySelector: {
          type: "object",
          required: ["amount", "type"],
          properties: {
            amount: {
              minLength: 1,
              type: "string",
              not: {
                anyOf: [
                  { pattern: "^[+-]?(0+([.]0*)?|[.]0+)$" },
                  { pattern: "^[+-]?(0+([.]00[0-9]*)?|[.]00[0-9]*)$" }
                ]
              }
            },
            type: {
              minLength: 1,
              type: "string"
            }
          }
        },
        value: {
          type: "object",
          properties: {
            sentiment: {
              type: "string"
            }
          },
          required: ["sentiment"]
        }
      }
    }
  };
}, Ya = ({
  headerText: t,
  headerStyles: a,
  helperText: o,
  helperStyles: e,
  options: n,
  renderOption: i,
  limit: s,
  getLabel: u,
  entityPath: l,
  alertLabel: f,
  alertIcon: d,
  alertStyle: p
}) => ({
  viewSchema: {
    id: "selectionList",
    editable: {
      view: "standard",
      fields: [
        {
          id: "selectionListHeading",
          renderAs: "heading",
          entityPath: [...l],
          headerText: t,
          headerStyles: a,
          helperText: o,
          helperStyles: e,
          alertLabel: f,
          alertIcon: d,
          alertStyle: p
        },
        {
          id: "customizableList",
          renderAs: "customizableList",
          entityPath: [...l],
          renderOption: i,
          options: n,
          getLabel: u,
          answerLimit: s
        }
      ]
    }
  },
  dataSchema: {
    $id: "selectionList",
    $schema: "http://json-schema.org/draft-07/schema#",
    description: "selection list form",
    type: "object",
    properties: {
      choices: {
        type: "object"
      }
    }
  }
});
export {
  Pa as CustomizableList,
  wa as FormHeading,
  Ia as GuidanceBox,
  Bn as GuidanceBoxIconEnum,
  r as JobSeekerProfileStructuredDataSalaryType,
  Oa as LocationInput,
  dn as MultilineChip,
  Ma as MultilineChipContainer,
  bn as PAY_BOUNDS,
  kn as PayInput,
  Ra as PaySelector,
  Wn as PeriodSelect,
  Hn as TextInput,
  La as Title,
  cr as countryCodeToCurrency,
  Or as getLocaleCurrency,
  Ua as getMinimumPaySchema,
  br as getPayTypes,
  Ca as getPayTypesWithoutPrefix,
  xn as getPayValueList,
  Ya as getSelectionListSchema,
  Na as parseLocaleCurrencyAmount,
  Fn as validatePayRange
};
